import "rsuite/dist/rsuite.min.css";
import "react-datepicker/dist/react-datepicker.css";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { modalAnatomy as parts } from "@chakra-ui/anatomy";
import {Modal,ModalOverlay,ModalContent,ModalHeader,ModalFooter,ModalBody,ModalCloseButton,Button,Tooltip,Box,Text} from "@chakra-ui/react";
import {Col,Form,Row} from "react-bootstrap";
import {createMultiStyleConfigHelpers,defineStyle,} from "@chakra-ui/styled-system";
import DatePicker from "react-datepicker";
import CurrencyFormat from 'react-currency-format';
import { createListForSingleOption, createOption } from "../createableSelect";
import getINRTotal from "jsFunctions/getINRAmount";
import PaymentInfoComponent from "../paymentInfoComponent";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import moment from "moment";
import { poNumberFormate,checkTotalApprovedAmountWithSpentAmount,checkApprovalAmount ,calculateTotalCredit} from "jsFunctions/helperFunctions";
import CustomSelect from "components/CustomSelect";
import { FormValidation } from "validation";
import { fetchAsyncGetFormOptions } from "redux/formOptions";
import { InputGroup, Tab, Tabs } from "react-bootstrap";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import ClientProjectSelect from "components/ClientProjectSelect";
import { clientProjectOptions } from "jsFunctions/clientProjectOptions";
import GstInfoComponent from "../gstInfoComponent";
import { fetchAsyncGetTDSExpenseByRefrencePO,fetchAsyncGetPONumTDSExpense } from "redux/tdsSlice";
import calculateTds from "jsFunctions/calculateTds";
import RefundInfoListComponent from "../refundListInfoComponent";
import { fetchAsyncGetClient } from "redux/clientProjectSlice";
import { fetchAsyncGetVendorByID ,fetchAsyncGetVendor,fetchAsyncGetTotalPayAmountByPanNumber} from "redux/vendorSlice";
import QuotationForm from "../seprateFormComponent/quatationForm";
import { FaCheck, FaFileUpload, FaPlus, FaPlusCircle } from "react-icons/fa";
import { fetchAsyncGetAllQuotation } from "redux/quotationSlice";
import DownloadExcelFile from "../DownloadExcel/downloadExcel";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { calculateTotalGst,getOptionDataOnEdit,extractGstData,calculateTotalBaseAmount } from "jsFunctions/calculateGst";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { spentAmountValidate } from "validation/spentAmount";
import { gstAmountValidate } from "validation/gstAmount";
import { fetchAsyncGetTotalCreditAmount,fetchAsyncGetCreditOptionsByVendorId ,fetchAsyncDeleteCreditListItem} from "redux/creditSlice";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import { refundAmountValidate } from "validation/refundAmount";
import CreditForm from "../seprateFormComponent/creditForm";
import CreditApplicable from "../seprateFormComponent/creditApplicable";
import { addCreditAmountValidate } from "validation/creditAmount";
import { creditAmountMismatch, isValidateCredit } from "../CreditAmount/credit";
import AmountPopover from "../amountPopover/addAmountPopover";
import TdsExpense from "../tdsExpense";
import { calculateTdsAmount, calculateTdsBaseAmount } from "../PurchaseOrder/helperFunction";
import { tdsAmountValidate } from "validation/tdsAmount";
import { createFormOptionApi, createMinorSubCategoryApi, createSubCategoryApi, deleteFromOptionApi, deleteMinorSubCategoryApi, deleteSubCategoryApi, editFromOptionApi, editMinorSubCategoryApi, editSubCategoryApi, getMinorSubCategoryApi, getSubCategoryApi } from "../CommonApi/form_options";
import prJson from "components/jsonData/purchase.json";
import commonJson from "components/jsonData/common.json";
import { fetchAsyncSendRequestForTotalPayAmount,fetchAsyncGetPONum,fetchAsyncApproveTotalPayAmount,fetchAsyncRejectTotalPayAmount,fetchAsyncUpdateExpense,fetchAsyncDeleteExpensePdf,fetchAsyncDeletePaymentListItem,fetchAsyncDeleteRefundListItem,fetchAsyncDeleteTdsListItem,fetchAsyncDeleteGstListItem,fetchAsyncUpdateRequestForTotalPayAmount,fetchAsyncUploadExpenseInvoice,fetchAsyncAddInvoiceRemark } from "redux/OrganizationExpenseSlice";
import ExpenseDataChangeModal from "components/models/DataChange/expenseDataChangeModal";
import PanNumberField from "../seprateFormComponent/panNumberField";
import { RiFileDownloadLine } from "react-icons/ri";
import InvoiceComponent from "../seprateFormComponent/InvoiceComponent";
import { sumOfPaymentRecordAmount,sumOfRefundAmount } from "utiils/halper";
import TextAreaField from "../component/textAreaField";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const xl = defineStyle({px: "6",py: "2",fontSize: "xl"});
const sm = defineStyle({fontSize: "sm",py: "6"});
const sizes = {xl: definePartsStyle({ header: sm, dialog: xl })};
export const modalTheme = defineMultiStyleConfig({sizes});

const OrganizationExpenseForm = (props) => {
  const {openExpenseModal,closeExpenseModal,isEdit = false,editData,refreshEditData,activeList,role,expenseType,moduleInfo,prefix} = props
  const formOptionsList1 = useSelector((state) => state.formOptions);
  const subCategoryList1 = useSelector((state) => state.subCategory);
  const dateRange = useSelector((state) => state.dateRange); 
  const { startDate } = dateRange;

  const [poPrefix, setPoPrefix] = useState({
    prfx: prefix,
    m: new Date().getMonth() + 1,
    y: new Date().getFullYear(),
    n: 1,
  });

  const [formOptionsList, setFormOptionsList] = useState([])
  const [subCategoryList, setSubCategoryList] = useState([])
  const [getPoMonth, setGetPoMonth] = useState("");
  const [generatedNum, setGeneratedNum] = useState(prefix);
  const [clientOPtion, setClientOption] = useState([]);
  const [merchantOption, setMerchantOPtion] = useState([]);
  const [resourceOption, setResourceOptions] = useState([]);
  const [minorTypeOption, setMinorTypeOption] = useState([]);
  const [projectOption, setProjectOption] = useState([]);
  const [expenseOption, setExpenseOption] = useState([]);
  const [officeTypOption, setOfficeTypeOption] = useState([]);
  const [agencyOption, setAgencyOPtion] = useState([]);
  const [minorSubCategoryOption, setMinorSubCategoryOption] = useState([]);
  const [multipleAddRefundInfo, setMultipleAddRefundInfo] = useState([{}]);
  const [roundOfAmount, setRoundOfAmount] = useState("")
  const [approveOrRejectRemarks, setApproveOrRejectRemarks] = useState('')
  const [multipleCredit, setMultipleCredit] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState(0);
  const [panNumber, setPanNumber] = useState("");
  const [currencyOption, setCurrencyOption] = useState([]);
  const [totalAmount, setTotalAmount] = useState('');
  const [INRVal, setINRVal] = useState();
  const [convertedVal, setConvertedVal] = useState("");
  const [isFreight, setIsFreight] = useState(false);
  const [totalPaymentAmount, setTotalPaymentAmount] = useState(0);
  const [approvalAmount, setApprovalAmount] = useState('');
  const [creditAmount, setCreditAmount] = useState("");
  const [clientValue, setClientValue] = useState("");
  const [minorTypeValue, setMinorTypeValue] = useState("");
  const [taxableAmount, setTaxableAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [multipleTdsInfo, setMultipleTdsInfo] = useState([{}]);
  const [totalPayAmountByPanNumber, setTotalAmountByPanNumber] = useState({})
  const [projectValue, setProjectValue] = useState("");
  const [merchantValue, setMerchantValue] = useState("");
  const [expenseValue, setExpenseValue] = useState("");
  const [officeTypeValue, setOfficeTypeValue] = useState("");
  const [agencyValue, setAgencyValue] = useState("");
  const [minorSubCategoryValue, setMinorSubCategoryValue] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [invoiceDate, setInvoiceDate] = useState(new Date());
  const [reimbursePaymentDate, setReimbursePaymentDate] = useState(new Date());
  const [currencyValue, setCurrencyValue] = useState("");
  const [multipleInvoiceData, setMultipleInvoiceData] = useState([]);
  const dispatch = useDispatch();
  const [multipleAddPaymentInfo, setMultipleAddPaymentInfo] = useState([]);
  const [spentAmountError, setSpentAmountError] = useState([{}]);
  const [refundAmountError, setRefundAmountError] = useState([{}]);

  const [gstAmountError, setGstAmountError] = useState([{}]);
  const [creditError, setCreditError] = useState([{}]);
  const [isHovered, setIsHovered] = useState(false);
  const [billNumber, setBillNumber] = useState("");

  const [totalCreditAmount,setTotalCreditAmount] = useState(0)
  // data  change modal
  const [compareDataModal, setCompareDataModal] = useState(false);
  const [comparingData, setComparingData] = useState(null);
  const [isGst, setIsGst] = useState(false);
  const [isRefund, setIsRefund] = useState(false);
  const [addCredit, setAddCredit] = useState(false)
  const [multipleAddGstInfo, setMultipleAddGstInfo] = useState([""]);
  const [isTds, setIsTds] = useState(false);
  const [amountTotal, setAmountTotal] = useState('');
  const [tdsAmount, setTdsAmount] = useState(0);
  const [isBlink, setIsBlink] = useState(false)
  const [isGenerateTDSPo, setIsGenerateTDSPo] = useState(false);
  const [generatedTDSpoNum, setGeneratedTDSpoNum] = useState("PR-T-");
  const [fullTdsData, setFullTdsData] = useState({})
  const [tdsPoPrefix, setTdsPoPrefix] = useState({
    prfx: "PR-T-",
    m: new Date().getMonth() + 1,
    y: new Date().getFullYear(),
    n: 1,
  });

  const [openQuotation, setOpenQuotation] = useState(false) 
 
  const [quotationData, setQuotationData] = useState({
    remarks:"",
    amount:"",
    files:""
  })

  const [isCredit, setIsCredit] = useState(false);

  const [creditValid, setCreditValid] = useState(true)
  const [isAddCredit,setIsAddCredit] = useState(false)
  const [tdsAmountError, setTdsAmountError] = useState([{}]);

  const startOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
  const endOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0); 
  
  const totalSpentAmount = useMemo(() => {
    if (multipleAddPaymentInfo) {
      if (multipleAddPaymentInfo.length > 0) {
        const total = sumOfPaymentRecordAmount(multipleAddPaymentInfo || [])
        const totalRefund = sumOfRefundAmount(multipleAddRefundInfo || [])
        return parseFloat(total) - parseFloat(totalRefund); 
      }
    }
    return 0;
  }, [multipleAddPaymentInfo,multipleAddRefundInfo]);

  const remainingAmount = useMemo(() => {
    if (multipleAddPaymentInfo) {
        const total = sumOfPaymentRecordAmount(multipleAddPaymentInfo || [])
        return parseFloat(totalPaymentAmount) - parseFloat(tdsAmount) - parseFloat(creditAmount) - parseFloat(total); 
    }
    return 0;
  }, [multipleAddPaymentInfo,totalPaymentAmount,tdsAmount,creditAmount]);

  useEffect(()=>{
    if(startDate && !isEdit){
      const formattedMonth = moment(startDate).format("YYYY-MM");
      setGetPoMonth(formattedMonth);
    }
    else{ 
      setGetPoMonth(moment().format("yyyy-MM"))
    }
    
  },[startDate])
  
  const getTotalPayAmount = async(panNo)=>{
    await dispatch(fetchAsyncGetTotalPayAmountByPanNumber(panNo)).then((res)=>{
  
      if(res?.payload){
      setTotalAmountByPanNumber(res?.payload)
        
      }
      }).catch((err)=>{
        setTotalAmountByPanNumber({})
  
        console.log(err)
      })
  }
  useEffect(()=>{
    if(panNumber){
      getTotalPayAmount(panNumber)
    }
  },[panNumber])
  const [allCreditOption, setAllCreditOptions] = useState([])
  useEffect(()=>{
    if(getPoMonth && !isEdit){
      const formattedMonth = moment(getPoMonth).format("YYYY-MM");
     
      setGetPoMonth(formattedMonth);
      
      if (moment(formattedMonth).isSame(moment(), 'month')) {
        const creditDate = moment().toDate(); 
        setSelectedDate(creditDate); 
      }
      else{

        const firstDayOfMonth = moment(formattedMonth).startOf('month').toDate();
        setSelectedDate(firstDayOfMonth);
      }
    }
    
  },[getPoMonth])
  
  const [allQuotation,setAllQuotation] = useState([])
  
  const [allCreditData, setAllCreditData] = useState([])
  
  const finalRef = useRef(null);
  const { addToast } = useToasts();
  const [remarksValue, setRemarksValue] = useState('');
  const [errors, setErrors] = useState({})
  const clientData = useSelector((state) => state.clientData);
  const vendorList = useSelector((state) => state.vendorData);
  
  const [activeTab, setActiveTab] = useState('')
  
  const initialValues = {
    poNo: "",
    orderMonth: null,
    orderDate: null,
    clientName: "",
    projectName: "",
    merchantName: "",
    remarks: "",
    expenseType: "",
    isExpense: false,
    agency: "",
    trackingNum: editData?.exp?.trkNo || "",
    totalPayAmount: 0,
    payee: "",
    paymentAmount: 0,
    approvalAmount: 0,
    bank: "",
    referenceNo: "",
    paymentdate: null,

    invoiceNum: editData?.rmbInfo?.inNo || "",
    invoiceDate: null,
    isReimburse:
      editData?.rmbInfo?.isRmb?.sts || false,

    reimbursePaymentDate: null,
    currency: "",
    reimburseAmount: 0,
    conversionRate: 0,
    amountInINR: 0,
    invoice: "",
  };

  useEffect(() => {
    dispatch(fetchAsyncGetClient())
    dispatch(fetchAsyncGetVendor());
    dispatch(fetchAsyncGetFormOptions())
   
    if(!isEdit){
      setTimeout(() => {
        setIsBlink(true)
      }, 3000); 
      setTimeout(() => {
        setIsBlink(false);
      }, 4000); 
    }
  }, []);
  useEffect(() => {
    setGeneratedNum(poNumberFormate(poPrefix));
  }, [poPrefix]);

  useEffect(() => {
    if (!isEdit && getPoMonth) {
      const dataSplit = getPoMonth.split("-");
      dispatch(
        fetchAsyncGetPONum({
          month: dataSplit[1],
          year: dataSplit[0],
          moduleId:moduleInfo?._id
        })
      )
        .then((res) => {
          let newNumber = 1;
          if (res.payload?.[0]?.poNo) {
            newNumber = res.payload?.[0]?.poNo.n + 1;
          }
          setPoPrefix((prev) => {
            return {
              prfx: prev.prfx,
              m: dataSplit[1],
              y: dataSplit[0],
              n: newNumber,
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getPoMonth]);


  const getAllMerchantOptions = async()=>{
    const filteredVendors = vendorList.filter(vendor => vendor.isV === true);

      const companyOption = await clientProjectOptions('name','_id',filteredVendors) 
      setMerchantOPtion(companyOption);
      const filteredConslutent = vendorList.filter(vendor => vendor.isC === true);
      const consultents = await clientProjectOptions('name','_id',filteredConslutent) 
      setResourceOptions(consultents)
  }
  useEffect(()=>{
    if(vendorList){
      getAllMerchantOptions()
    }
  },[vendorList])
  useEffect(()=>{
    if(formOptionsList1 && formOptionsList1?.length > 0){
      const internalFormOptionList = formOptionsList1.filter((item)=> item.expTyp === expenseType)
      setFormOptionsList(internalFormOptionList)
    }
  },[formOptionsList1])

  useEffect(()=>{
    if(subCategoryList1 && subCategoryList1?.length > 0){
      const internalSubCategoryList = subCategoryList1.filter((item)=> item.expTyp === expenseType)
      setSubCategoryList(internalSubCategoryList)
    }
  },[subCategoryList1])

  useEffect(() => {
    if(currencyValue && currencyValue?.value !== 'INR'){
      setConvertedVal(getINRTotal(totalAmount, INRVal));
    }
    else{
      setConvertedVal(totalAmount);
      setINRVal(1)
    }  
  }, [INRVal, totalAmount,currencyValue]);
  const closeComparedDataModal = () => {
    setCompareDataModal(false);

    setComparingData(null);
  };
  const submitUpdateData = (formData, editData) => {
    setIsLoading(true)
    dispatch(
      fetchAsyncUpdateExpense({ id: editData._id, formData: formData,moduleId:moduleInfo?._id })
    )
      .then((res) => {
        if (res.payload) {
          const msg = prJson.confirm.updatePurchase.replace("{generatedNum}", generatedNum);

          addToast(msg, { appearance: "success" });
          setIsLoading(false)
        }
        closeExpenseModal('approved');
        formik.resetForm();
      })
      .catch((error) => {
        setIsLoading(false)
        addToast(prJson.error.generic, { appearance: "error" });
      });
  };

  const getAllClientOptions = async()=>{
    if(clientData){

      const clientOption = await clientProjectOptions('clName','_id',clientData) 
      setClientOption(clientOption);
    }
  }

  const getAllProjectOptions = async(clientId)=>{
    const client = clientData.find(client => client._id === clientId);
    if(client){

      const projects = client?.prjs || []
      if(projects){
        const projectOption = await clientProjectOptions('prj','_id',projects) 
        setProjectOption(projectOption);
        setProjectValue("");
        if (isEdit && editData && editData?.prId && editData.prId?._id) {
              const subCat = projectOption.filter(
                (option) => option.value === editData.prId?._id
              );
              if (subCat[0]) {
                setProjectValue({
                  label: subCat[0].label,
                  value: subCat[0].value,
                });
              }
            }
      }
    }
}

   // Set MinorCategory for selected majorType value
   useEffect(() => {
    if (!isEdit && role === 'Accountant') {
      const projectOption = clientProjectOptions('prj','_id', clientData?.flatMap(c => c.prjs) ?? [])
      setProjectOption(projectOption);
    } else {
      getAllProjectOptions(editData?.clId?._id);
    }
  }, []);
  useEffect(() => {
    getAllClientOptions()
    let agencyList = createListForSingleOption(formOptionsList, "agency");
    let expenseList = createListForSingleOption(formOptionsList, "expense");
    let officeList = createListForSingleOption(formOptionsList, "office-type");

    let currencyList = createListForSingleOption(formOptionsList, "currency");
    setAgencyOPtion(agencyList);
    setExpenseOption(expenseList);
    setOfficeTypeOption(officeList)
    setCurrencyOption(currencyList);
  }, [formOptionsList]);

  const getFormData = (values)=>{
    let formData = new FormData();
    formData.append("poNo", JSON.stringify(poPrefix));
    formData.append("orderMonth", getPoMonth);
    formData.append("orderDate", selectedDate);
    formData.append("clientName", clientValue?.value);
    formData.append("minorType", minorTypeValue.value);
    formData.append("merchantName", merchantValue?.label);
    formData.append("taxableAmount", taxableAmount);
    formData.append("roundOfAmount", roundOfAmount);
    formData.append("minorTypeCategory", minorSubCategoryValue.value ? minorSubCategoryValue.value : '');
    formData.append("projectName", projectValue?.value);
    formData.append("merchantId", merchantValue.value || "");
    formData.append("remarks", remarksValue);
    formData.append("expenseType", expenseValue?.value);
    formData.append("officeType", officeTypeValue?.value);
    formData.append("officeId", officeTypeValue?.id || "");
    formData.append("billNumber", billNumber);

    formData.append("majorId", expenseValue.id || "");
    formData.append("minorId", minorTypeValue?.id || "");
    formData.append("minorSubCategoryId", minorSubCategoryValue?.id || "");
    formData.append("agencyId", agencyValue?.id || "");
    formData.append("isExpense", isFreight);
    formData.append("agency", agencyValue?.value);
    formData.append("trackingNum", values.trackingNum);
    formData.append("totalPaymentAmount", totalPaymentAmount);
    formData.append("approvalAmount", approvalAmount);
    formData.append("isGST", isGst);
    formData.append("moduleType", moduleInfo?.typ);
    formData.append("expense_name", moduleInfo?.name);

    formData.append("isTDS", isTds);
    amountTotal && formData.append("totalAmount", amountTotal);
    !isNaN(tdsAmount) && formData.append("totalTDS", tdsAmount);
    formData.append("isTDSPO", isGenerateTDSPo);
    formData.append("TDSPONum", JSON.stringify(tdsPoPrefix));
    formData.append("invoiceNum", values.invoiceNum);
    formData.append("invoiceDate", invoiceDate);
    formData.append("isReimburs", values.isReimburse);
    formData.append("reimbursementPaymentDate", reimbursePaymentDate);
    currencyValue?.value && formData.append("currency", currencyValue?.value);
    formData.append("currencyId", currencyValue?.id || "");
    totalAmount && formData.append("reimburseAmount", totalAmount);
    INRVal && formData.append("conversionRate", INRVal);
    convertedVal && formData.append("amountInINR", convertedVal);
    formData.append("gstInfo", JSON.stringify(multipleAddGstInfo));
    formData.append("isRefund", isRefund);
    const filteredMultipleAddRefundInfoPay = multipleAddRefundInfo?.filter((item) => item?.amt);      
    
    formData.append("refundInfo", JSON.stringify(filteredMultipleAddRefundInfoPay));
    formData.append("approveRejectRemarks", approveOrRejectRemarks);

    const filteredMultipleAddTdsInfo = multipleTdsInfo?.filter((item) => item?.tlAmt);      
    formData.append("tdsInfo", JSON.stringify(filteredMultipleAddTdsInfo));
   
    if(quotationData  && (quotationData?.files?.length > 0 || quotationData?.remarks)){
      formData.append('quotation_remarks', quotationData?.remarks);
     formData.append('quotation_amount', quotationData?.amount);
     Array.from(quotationData?.files).forEach((file) => {
         formData.append('quotation_files', file);
     });

   }

   const filteredInvoice = multipleInvoiceData?.filter((item) => item?.file);     
   formData.append("invoiceData", JSON.stringify(filteredInvoice));
   filteredInvoice.forEach((inv, idx) => {
    formData.append(`invoiceFiles[${idx}]`, inv.file);
  });
    return formData;
  }

  const formik = useFormik({
    initialValues,
    validationSchema: FormValidation,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      if ((moduleInfo?.typ !== 'Internal' && !clientValue) || !minorTypeValue  || (moduleInfo?.typ !== 'Internal' && !projectValue) || !merchantValue || !expenseValue || (minorSubCategoryOption && minorSubCategoryOption?.length && !minorSubCategoryValue)) {
        setErrors({
          ...errors,
          projectValue:moduleInfo?.typ !== 'Internal' && paymentStatus === 0 ? prJson.required.project : "",
          minorTypeValue:prJson.required.minorType,
          merchantValue:paymentStatus === 0 ?prJson.required.merchant:"",
          expenseValue:prJson.required.majorType,
          clientValue:moduleInfo?.typ !== 'Internal' && paymentStatus === 0 ? prJson.required.clientName:"",
          minorSubCategoryValue:minorSubCategoryOption && minorSubCategoryOption?.length ?  prJson.required.minorSub: ''
        })     
        addToast(prJson.required.allField, { appearance: "error" });
        return;
      }
     
      const spentError = spentAmountValidate(
        multipleAddPaymentInfo,remainingAmount
      );
      if (Object.keys(spentError).length !== 0) {
        setSpentAmountError(spentError)
        if(activeTab && activeTab !== 'spent'){
          addToast(prJson.error.checkSpent, { appearance: "error" });
        }
        return;
      }
      if(isGst){
      const gstError = gstAmountValidate(
        multipleAddGstInfo,
        taxableAmount
      );
      if (Object.keys(gstError).length !== 0) {
        setGstAmountError(gstError)
        if(activeTab !== 'gst'){
          addToast(prJson.error.checkGst, { appearance: "error" });
        }
        return;
      }
      }
      if(isTds){
        const tdsError = tdsAmountValidate(
          multipleTdsInfo,
          taxableAmount
        );
        if (Object.keys(tdsError).length !== 0) {
          setTdsAmountError(tdsError)
          if(activeTab && activeTab !== 'tds'){
            addToast(prJson.error.checkTds, { appearance: "error" });
          }
          return;
        }
        }
      if(isRefund){
        const refundError = refundAmountValidate(
          multipleAddRefundInfo,remainingAmount
        );
        if (Object.keys(refundError).length !== 0) {
          setRefundAmountError(refundError)
          if(activeTab !== 'refund'){
            addToast(prJson.error.checkRefund, { appearance: "error" });
          }
          return;
        }
        }
      const checkApproval = checkApprovalAmount(
        approvalAmount,
      );
      if (!checkApproval.status) {
        setErrors({
          ...errors,
          approvalAmount:checkApproval.msg
        })         
        return;
      }
      const filteredMultipleAddPaymentInfo = multipleAddPaymentInfo.filter((item) => item?.amt);

      const checkValid = checkTotalApprovedAmountWithSpentAmount(
        totalPaymentAmount,
        filteredMultipleAddPaymentInfo
      );
      if (!checkValid.status) {
        setErrors({
          ...errors,
          approvalAmount:checkValid.msg
        })
        // addToast(checkValid.msg, { appearance: "error" });
        return;
      }

      let formData = getFormData(values);

      const filteredMultipleAddPaymentInfoPay = filteredMultipleAddPaymentInfo.map((item)=>{
        if(item?.inv){
          return {
            ...item,
            inv: item?.inv.filter(entry => 'Key' in entry)
          }
        }
        else{
          return item
        }
      });
     
      formData.append("payInfo", JSON.stringify(filteredMultipleAddPaymentInfoPay));
     
      if (isEdit) {
        setComparingData(formData);
      } 
    },
  });

  
  const removeItemFromState = (index) => {
    // Update your local state to remove the item at the specified index
    setMultipleAddGstInfo(prevState => prevState.filter((_, i) => i !== index));
    const filterGst = multipleAddGstInfo.filter((_, i) => i !== index);
    if(!filterGst?.length){
      setIsGst(false)
    }
  }
  const deleteMultipleGstItem = (id,index)=>{
    if(id){
      ConfirmationDialog({
        title: prJson.confirm.deleteAmt,
        text: '',
        icon: 'warning',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        onConfirm: () => {

          dispatch(fetchAsyncDeleteGstListItem({moduleId:moduleInfo?._id,id})).then((res) => {
            removeItemFromState(index);
            refreshEditData();
            addToast(prJson.success.deletedGst, { appearance: "success" });
          });
        }
      });
    }
    else{
      removeItemFromState(index)
    }
  }
 

  const handleInvoiceChange = () => {
        if(multipleInvoiceData){
           if (multipleInvoiceData?.length < 5) {
            setMultipleInvoiceData([
              ...multipleInvoiceData,
              {
                spId:"",
                Key:"",
                remark:"",
                file:""
              },
            ])
         }
        }
};

  const handleMultiplePayInfo = (data) => {
    setMultipleAddPaymentInfo([
      ...multipleAddPaymentInfo,
      {
        amt:remainingAmount,
        pmtDt:new Date()
      },
    ]);
  };
 
  const handleUpdateMultiplePayData = (payData, index) => {
    const updateList = multipleAddPaymentInfo.map((item, i) => {
      if (i === index) {
        return {...item,...payData};
      } else return item;
    });

    const sum = updateList.reduce((acc, current) => {
      if (current?.amt && current?.amt !== '') {
        return acc + parseFloat(current?.amt);
      } else {
        return acc;
      }
    }, 0);  

    const total_pay_amount = parseFloat(totalPaymentAmount) - parseFloat(tdsAmount)
    if(total_pay_amount){

      const remaning = parseFloat(total_pay_amount) - parseFloat(sum)
      const spentError = spentAmountValidate(
        updateList,
        remaning
      );
      if (spentError) {
        setSpentAmountError(spentError)
      }
    }
    setMultipleAddPaymentInfo([...updateList]);
  };

   // payment info function
   const handleMultipleGstInfo = (data) => {
    setMultipleAddGstInfo([
      ...multipleAddGstInfo,
      ""
    ]);
  };
   // payment info function
   const handleMultipleTDSInfo = (data) => {
    setMultipleTdsInfo([
      ...multipleTdsInfo,
      { paydata: data.data },
    ]);
  };

  const handleUpdateMultipleGstData = async(gstData, index) => {
    const companyId = gstData?.vId?.value || merchantValue?.value
   
    
    
    const updateList = multipleAddGstInfo.map((item, i) => {
      const gstFullData = {
        bsAmt:gstData?.bsAmt,
        vId:companyId,
        gstNo:gstData?.gstNo ,
        amt:gstData?.amt || {},
        prc: gstData?.prc
      }
      if (i === index) {
        return {...item,gstFullData};
      } else 
      return item;
    });

    const gstError = gstAmountValidate(
      updateList,
      taxableAmount
    );
    if (Object.keys(gstError).length !== 0) {
      setGstAmountError(gstError)
    }
    else{
      setGstAmountError({})

    }    
    setMultipleAddGstInfo([...updateList]);
  };
  
  const handleUpdateMultipleTdsData = (payData, index) => {
    let tdsAmount = 0;
    if(payData.bsAmt){

      tdsAmount = calculateTds(payData.bsAmt ,payData.prc || 10);
    }
    const updatedPayData = {
      ...payData,
      tlAmt: tdsAmount 
    };
  
    const updateList = multipleTdsInfo.map((item, i) => {
      if (i === index) {
        return {...item,...updatedPayData};
      } else return item;

    });
    const tdsError = tdsAmountValidate(
      updateList,
      taxableAmount
    );
    if (Object.keys(tdsError).length !== 0) {
      setTdsAmountError(tdsError)
    }
    else{
      setTdsAmountError({})

    }    
    setMultipleTdsInfo([...updateList]);
  };

  const handleMultipleRefundInfo = (data) => {
    setMultipleAddRefundInfo([
      ...multipleAddRefundInfo,
      { paydata: data.data },
    ]);
  };
  const handleUpdateMultipleRefundData = (payData, index) => {
    const updateList = multipleAddRefundInfo.map((item, i) => {
      if (i === index) {
        return {...item,...payData};
      } else return item;

    });
    const refundError = refundAmountValidate(
      updateList,
      remainingAmount
    );
    if (refundError) {
      setRefundAmountError(refundError)
    }
    else{
      setRefundAmountError({})
    }
    setMultipleAddRefundInfo([...updateList]);
  };

  const handleUpdatedMultipleCredit = (newItem) => {
  const updatedList = multipleCredit.map((item)=>{
    if(item?._id === newItem?._id){
      return newItem
    }
    else{
      return item;
    }
  })
  const creditError = addCreditAmountValidate(
    updatedList,totalCreditAmount
  );
  if (creditError) {
    setCreditError(creditError)
  }
 
  setMultipleCredit(updatedList);
 
  };

 
  
  const handleUpdateInvoiceData = (invoiceData, index) => {
    const newData = [...multipleInvoiceData];
    newData[index].file = invoiceData;
    setMultipleInvoiceData(newData);
  };

  const handleAddInvoiceRemarks = (value, index) => {
    const newData = [...multipleInvoiceData];
    newData[index].remark = value
    setMultipleInvoiceData(newData);
  };
  const handelDeleteInvoice = (index) => {
        if(multipleInvoiceData){
          let invoices = multipleInvoiceData.filter((item, i) => i !== index)
          setMultipleInvoiceData(invoices);
        }
  };

  const handleStateUpdate = (type, setData) => {
    const typeHandlers = {
      expense: () => {
        setExpenseValue(setData);
        setMinorTypeValue('');
        setMinorSubCategoryValue('');
      },
      agency: () => {
        setAgencyValue(setData);
      },
      currency: () => {
        setCurrencyValue(setData);
      },
      'office-type':()=>{
          setOfficeTypeValue(setData);
      }
    };

    if (typeHandlers[type]) {
      typeHandlers[type]();
    }
  };

  const createNewFormOption = async(data, type) => {
    const setData = await createFormOptionApi(data, type, dispatch, expenseType);
    if (setData) {
      handleStateUpdate(type, setData);
    }
  };

  const deleteFromOption = (option, type) => {
    let data = formOptionsList.find(
      (item) => item._id === option.id && item.typ === type
    );
    if (data?._id) {
      deleteFromOptionApi(dispatch, data._id).then((result) => {
        if (result.success) {
          addToast(result.message, { appearance: 'success' });
        } else {
          addToast(result.message, { appearance: 'error' });
        }
      });
    }
   
  };


  const handleQuotationData = (data)=>{
    setQuotationData(data)
  }

  const editFromOption = (option,newValue, type) => {
      let data = formOptionsList.find(
        (item) => item._id === option.id && item.typ === type
      );
      editFromOptionApi(dispatch,data._id, newValue, expenseType).then((result) => {
        if (result.success) {
          addToast(prJson.success.updatedOpt, { appearance: 'success' });
          if (result.data) {
            handleStateUpdate(type, result.data);
            dispatch(fetchAsyncGetFormOptions())
          }
        } else {
          addToast(result.message, { appearance: 'error' });
        }
      });
  };
  // Changes on Edit


  useEffect(() => {
    if (isEdit && editData) {
      if (!fullTdsData?.referenceResourcePO) {
        setGeneratedTDSpoNum(poNumberFormate(tdsPoPrefix));
      }
    } else {
      setGeneratedTDSpoNum(poNumberFormate(tdsPoPrefix));
    }
  }, [tdsPoPrefix, isGenerateTDSPo]);


 // TDS PO BY Resource
 useEffect(() => {
  const dataSplit = getPoMonth.split("-");
  const year =
    parseInt(dataSplit[1]) === 12
      ? parseInt(dataSplit[0]) + 1
      : parseInt(dataSplit[0]);
  let month = parseInt(dataSplit[1]) === 12 ? 1 : parseInt(dataSplit[1]) + 1 ;
  dispatch(
    fetchAsyncGetPONumTDSExpense({
      month: month,
      year: year,
    })
  )
    .then((res) => {
      if (res.payload?.[0]?.poNo) {
        if(fullTdsData?.referenceResourcePO){
          setTdsPoPrefix((prev) => {
            return {
              prfx: res.payload?.[0]?.poNo.prfx,
              m: res.payload?.[0]?.poNo.m,
              y: res.payload?.[0]?.poNo.y,
              n: res.payload?.[0]?.poNo.n,
            };
          });
        }
        else{

          setTdsPoPrefix((prev) => {
            return {
              prfx: prev.prfx,
              m: month,
              y: year,
              n: res.payload?.[0]?.poNo.n + 1,
            };
          });
        }
      } else {
        setTdsPoPrefix((prev) => {
          return {
            prfx: prev.prfx,
            m: month,
            y: year,
            n: 1,
          };
        });
      }
    })
    .catch((err) => {
      console.log("error", err);
    });
}, [isGenerateTDSPo, getPoMonth]);


  const editFormPrefiledData = (formOptionsList, editData) => {
    const clientData = editData?.clId
    if (clientData) {
      setClientValue({ label: clientData.clName, value: clientData._id });
    }

    const expense = getOptionDataOnEdit(
      formOptionsList,
      editData?.mjId?._id,
      "expense"
    );
    if (expense) {
      setExpenseValue({
        label: expense.lab,
        value: expense.val,
        id: expense?._id
      });
    }
    const office = getOptionDataOnEdit(
      formOptionsList,
      editData?.ofcId?._id,
      "office-type"
    );
    if (office) {
      setOfficeTypeValue({
        label: office.lab,
        value: office.val,
        id: office?._id
      });
    }
    
    if (editData?.exp?.sts) {
      const agencyData = getOptionDataOnEdit(
        formOptionsList,
        editData?.exp?.adId?._id,
        "agency"
      );
      if (agencyData && !agencyValue) {
        setAgencyValue({
          label: agencyData.lab,
          value: agencyData.val,
          id: agencyData?._id
        });
      }
    }
    
  };

  

  const handleCloseQuotation = ()=>{
    setOpenQuotation(!openQuotation)
    if (isEdit && editData) {
    getAllQuotation(editData?._id)
    }
  }


  const getAllQuotation = async(_id)=>{
    await dispatch(fetchAsyncGetAllQuotation(_id)).then((res)=>{

        if(res?.payload){
            const quotations = res.payload?.quotations;
            setAllQuotation(quotations)
        }
        }).catch((err)=>{
          console.log(err)
        })
}

const getMerchantByID = async(id)=>{
  await dispatch(fetchAsyncGetVendorByID(id)).then((res)=>{

  if(res?.payload){
    const vendor = res?.payload?.vendor;
    const setData = {
      label: vendor.name,
      value: vendor?._id,
    };
          
    setMerchantValue(setData);
    setPanNumber(vendor?.pnNo)

  }
  }).catch((err)=>{
    console.log(err)
  })
}

useEffect(()=>{
  if (formOptionsList?.length > 0 && isEdit && editData) {
    editFormPrefiledData(formOptionsList, editData);
  }
},[formOptionsList,editData]);

  useEffect(() => {
    // fill data in form on edit
    if (isEdit && editData) {
      
      getAllQuotation(editData?._id)

      setPoPrefix(editData.poNo);
      setSelectedDate(new Date(editData.oDt));

      setGetPoMonth(
        `${editData.poNo.y}-${
          editData.poNo.m < 9
            ? "0" + editData.poNo.m
            : editData.poNo.m
        }`
      );

      if(editData?.mrId && editData?.mrId?._id){
        getMerchantByID(editData?.mrId?._id)
      }
      else{
        if(editData?.resId && editData?.resId?._id){
          getMerchantByID(editData?.resId?._id)
        }
      }
    

     
      setIsFreight(editData?.exp?.sts || false);
      if (editData.pyInfo?.tlAmt) {
        setTotalPaymentAmount(editData.pyInfo?.tlAmt);
      }
      if (editData.pyInfo?.list && editData.pyInfo?.list.length > 0) {
        setMultipleAddPaymentInfo(editData.pyInfo?.list);
      }
      
     
      if (editData?.acRmks) {
        setApproveOrRejectRemarks(editData?.acRmks)
      }
      if (editData?.roAmt) {
        setRoundOfAmount(editData?.roAmt)
      }
      if (editData?.rmks) {
        setRemarksValue(editData?.rmks)
      }
      if (editData?.pyInfo?.blNo) {
        setBillNumber(editData?.pyInfo?.blNo || "")
      }
      else if(editData.pyInfo?.list && editData.pyInfo?.list?.length > 0) {
        setBillNumber(editData.pyInfo?.list[0]?.blNo || "");
      }
      if(editData.pyInfo?.inv && editData.pyInfo?.inv?.length > 0) {
        setMultipleInvoiceData(editData.pyInfo?.inv);
      }
      if (editData.rfdInfo?.list && editData.rfdInfo?.list.length > 0) {
        setMultipleAddRefundInfo(editData.rfdInfo?.list);
      }
      if (editData.tdsApl?.list && editData.tdsApl?.list.length > 0) {
        setMultipleTdsInfo(editData.tdsApl?.list);
      }
      if (editData.pyInfo?.sts) {
        setPaymentStatus(editData.pyInfo?.sts)
      }
      if (editData.pyInfo?.txAmt) {
        setTaxableAmount(editData.pyInfo?.txAmt);
      }

      if (editData?.gstApl && editData?.gstApl?.sts) {
        setIsGst(editData?.gstApl?.sts);
      }
      if (editData?.crApl && editData?.crApl?.sts) {
        setIsCredit(editData?.crApl?.sts);
      }
      if (editData?.crApl?.list && editData?.crApl?.list?.length > 0) {
        setMultipleCredit(editData.crApl?.list);
      }
    
      if (editData?.rfdInfo && editData?.rfdInfo?.sts) {
        setIsRefund(editData?.rfdInfo?.sts);
      }
    
      
     
      if (editData.pyInfo?.apAmt) {
        setApprovalAmount(editData.pyInfo?.apAmt);
      }
     
      if (editData.rmbInfo?.inDt) {
        setInvoiceDate(new Date(editData.rmbInfo.inDt));
      }
      if (editData.gstApl?.gstId && editData.gstApl?.gstId?.length > 0) {
        setMultipleAddGstInfo(editData.gstApl?.gstId);
      }
     
     

      if (editData.rmbInfo?.isRmb) {
        const { pmtDt, amt, cnvRt, inr } =
          editData.rmbInfo?.isRmb;
          pmtDt && setReimbursePaymentDate(new Date(pmtDt));
        setTotalAmount(amt);
        setINRVal(cnvRt);
        setConvertedVal(inr);

        const currencyData = getOptionDataOnEdit(
          formOptionsList,
          editData.rmbInfo?.isRmb?.crId,
          "currency"
        );
        if (currencyData) {
          setCurrencyValue({
            label: currencyData.lab,
            value: currencyData.val,
            id: currencyData?._id

          });
        }
      }
      
      if(editData?._id){
        dispatch(fetchAsyncGetTDSExpenseByRefrencePO(editData?._id)).then((res)=>{
          const tdsData = res?.payload?.tdsExpense
          if (res?.payload && tdsData) {
            if (tdsData?.rfPo) {
              setIsTds(editData.tdsApl?.sts);
              setAmountTotal(tdsData?.tlBlAmt);
              setTdsAmount(tdsData?.tdsAmt);
              setIsGenerateTDSPo(true);
              setGeneratedTDSpoNum(poNumberFormate(tdsData?.poNo));
            }
            setFullTdsData(tdsData);
          } else {
            if (editData.tdsApl?.sts) {
              setIsTds(editData.tdsApl?.sts);
              editData.tdsApl?.bsAmt &&
                setAmountTotal(editData.tdsApl?.bsAmt);
              editData.tdsApl?.tlAmt &&
                setTdsAmount(editData.tdsApl?.tlAmt);
            }
            
            
          }
        }).catch((err)=>{
          console.log(err)
        })
      }
     
    }
  }, [editData]);

  const handleDeleteInvoiceOnEdit = (key,spId) => {
    ConfirmationDialog({
      title: prJson.confirm.invoice,
      text: `Delete File ${key}`,
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setIsLoading(true)
        const sendData = {
          id: editData._id,
          moduleId:moduleInfo._id,
          key: key,
          spId: spId || ""
        };
        dispatch(fetchAsyncDeleteExpensePdf(sendData)).then((res) => {
          if(res?.payload && res?.payload?.customExpense?.pyInfo?.inv){

          setMultipleInvoiceData(res?.payload?.customExpense?.pyInfo?.inv)
          addToast(prJson.success.deletedInvoice, { appearance: "success" });
          setIsLoading(false)
          }
          else{
            setIsLoading(false)
            addToast(prJson.error.generic, { appearance: "error" });
          }

        }).catch((error) => {
          addToast(prJson.error.generic, { appearance: "error" });
          setIsLoading(false);
      });
      }
    });
  };

  const addNewInvoiceOnEdit = (file, index) => {
    ConfirmationDialog({
      title: prJson.confirm.uploade,
      text: `Upload - ${file.name}`,
      icon: 'warning',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        setIsLoading(true)

        if (editData) {
         
          let formData = new FormData();
          formData.append("poNo", JSON.stringify(editData.poNo));
          formData.append("file", file);
          formData.append("merchantId", merchantValue.val || "");
          formData.append("index", index);

          dispatch(
            fetchAsyncUploadExpenseInvoice({ id: editData._id,moduleId:moduleInfo?._id, formData })
          ).then((res) => {
            if(res?.payload && res?.payload?.customExpense?.pyInfo?.inv){
            setMultipleInvoiceData(res?.payload?.customExpense?.pyInfo?.inv)
            const billNo = billNumber ? billNumber : res?.payload?.customExpense?.pyInfo?.blNo;
            setBillNumber(billNo);
            setIsLoading(false)
            addToast(`Invoice Uploaded successfully!`, { appearance: "success" });
            }
            else{
              setIsLoading(false);
              addToast(`Invoice Not Uploaded!`, { appearance: "error" });

            }

          }).catch((error) => {
            addToast(`Invoice Not Uploaded!`, { appearance: "error" });
            setIsLoading(false);
        });
        }
      }
    });
  };



    const createSubCategory = (category, expenseData) => {
      const option = formOptionsList.find((data) => data._id === expenseData?.id);
      if (!option) return;
  
      createSubCategoryApi(dispatch, option._id, category, expenseType).then((result) => {
        if (result.success) {
          setMinorTypeOption((prev) => [
            ...prev,
            result.data,
          ]);
          setMinorTypeValue({
            label: result.data.label,
            value: result.data.value,
            id: result.data.id,
          });
          addToast(prJson.success.createdSub, { appearance: 'success' });
        } else {
          addToast(result.message, { appearance: 'error' });
        }
      });
    };
  
    const deleteSubCategory = (option) => {
      const id = option?._id;
      if (id) {
          deleteSubCategoryApi(dispatch, id).then((result) => {
            if (result.success) {
              setMinorTypeOption((prev) => prev.filter((cat) => cat.value !== result.value));
              addToast(prJson.success.deletedSub, { appearance: 'success' });
            } else {
              addToast(result.message, { appearance: 'error' });
            }
          });
      }
    };
  
    const editSubCategory = (option,newValue) => {
      editSubCategoryApi(dispatch, option?._id, newValue, expenseType).then((result) => {
        if (result.success) {
          if (expenseValue?.id) {
            getSubCategoryApi(dispatch, expenseValue.id).then((subCatResult) => {
              if (subCatResult.success) {
                const minorOpt = subCatResult.data.map((item) => ({
                  ...item,
                  label: item?.lab,
                  value: item?.val,
                  id: item?._id,
                }));
                setMinorTypeOption(minorOpt);
                if (minorOpt.length > 0) {
                  const subCat = minorOpt.find((opt) => opt.id === option?._id);
                  if (subCat) {
                    setMinorTypeValue({
                      label: subCat?.label,
                      value: subCat?.value,
                      id: subCat?._id,
                    });
                  }
                }
              } else {
                addToast(subCatResult.message, { appearance: 'error' });
              }
            });
          }
          addToast(prJson.success.updatedSub, { appearance: 'success' });
        } else {
          addToast(result.message, { appearance: 'error' });
        }
      });
     
    };
  
    const createMinorSubCategory = (category, minorTypeData) => {
      const option = subCategoryList.find((data) => data._id === minorTypeData?.id);
      if (!option) return;
      createMinorSubCategoryApi(dispatch, option._id, category, expenseType).then((result) => {
        if (result.success) {
          setMinorSubCategoryOption((prev) => [
            ...prev,
            result.data,
          ]);
          setMinorSubCategoryValue({
            label: result.data.label,
            value: result.data.value,
            id: result.data.id,
          });
          addToast(prJson.success.createdMinorSub, { appearance: 'success' });
        } else {
          addToast(result.message, { appearance: 'error' });
        }
      });
    };
  
    const deleteMinorSubCategory = (option) => {
      const id = option?._id;
      if (id) {
        deleteMinorSubCategoryApi(dispatch, id).then((result) => {
          if (result.success) {
            setMinorSubCategoryOption((prev) => prev.filter((cat) => cat.value !== result.value));
            addToast(prJson.success.deletedMinorSub, { appearance: 'success' });
          } else {
            addToast(result.message, { appearance: 'error' });
          }
        });
      }
    };

    const editMinorSubCategory = (option,newValue) => {
      editMinorSubCategoryApi(dispatch, option?._id, newValue, expenseType).then((result) => {
        if (result.success) {
          if (minorTypeValue?.id) {
            getMinorSubCategoryApi(dispatch, minorTypeValue.id).then((subCatResult) => {
              if (subCatResult.success) {
                const minorSubOpt = subCatResult.data.map((item) => ({
                  ...item,
                  label: item?.lab,
                  value: item?.val,
                  id: item?._id,
                }));
  
                setMinorSubCategoryOption(minorSubOpt);
                if (minorSubOpt.length > 0) {
                  const subCat = minorSubOpt.find((opt) => opt.id === option?._id);
                  if (subCat) {
                    setMinorSubCategoryValue({
                      label: subCat?.label,
                      value: subCat?.value,
                      id: subCat?._id,
                    });
                  }
                }
              } else {
                addToast(subCatResult.message, { appearance: 'error' });
              }
            });
          }
          addToast(prJson.success.updatedMinorSub, { appearance: 'success' });
        } else {
          addToast(result.message, { appearance: 'error' });
        }
      });
    }


   useEffect(() => {
    if (expenseValue?.id) {
      getSubCategoryApi(dispatch, expenseValue.id).then((subCatResult) => {
        if (subCatResult.success) {
          const minorOpt = subCatResult.data.map((item) => ({
            ...item,
            label: item?.lab,
            value: item?.val,
            id: item?._id,
          }));
          setMinorTypeOption(minorOpt);
          setMinorTypeValue("")
          if (isEdit && editData && minorOpt.length > 0) {
            const subCat = minorOpt.find((opt) => opt.id === editData?.mnId?._id);
            if (subCat) {
              setMinorTypeValue({
                label: subCat?.label,
                value: subCat?.value,
                id: subCat?._id,
              });
            }
          }
        }
      });
    }
  }, [expenseValue]);

   useEffect(() => {
    if (minorTypeValue?.id) {
      getMinorSubCategoryApi(dispatch, minorTypeValue.id).then((subCatResult) => {
        if (subCatResult.success) {
          const minorSubOpt = subCatResult.data.map((item) => ({
            ...item,
            label: item?.lab,
            value: item?.val,
            id: item?._id,
          }));
          setMinorSubCategoryOption(minorSubOpt);
          setMinorSubCategoryValue("");
          if (isEdit && editData && minorSubOpt.length > 0) {
            const subCat = minorSubOpt.find((opt) => opt.id === editData?.msId?._id);
            if (subCat) {
              setMinorSubCategoryValue({
                label: subCat?.label,
                value: subCat?.value,
                id: subCat?._id,
              });
            }
          }
        }
      });
    }
  }, [minorTypeValue]);
  
  const addRemarkForInvoice = (value,index) => {
    dispatch(
      fetchAsyncAddInvoiceRemark({
        id: editData._id,
        moduleId:moduleInfo?._id,
        remarkData: { remark: value, index },
      })
    ).then((res) => {
      setMultipleInvoiceData(res?.payload?.customExpense?.pyInfo?.inv)

      refreshEditData();
    });
  };

  const handleAmountApproveBtn = (values)=>{   
    if(!isEdit){
  
      if ((moduleInfo?.typ !== 'Internal' && paymentStatus === 0 && !clientValue)  || !minorTypeValue || (moduleInfo?.typ !== 'Internal' && paymentStatus === 0 && !projectValue) || (paymentStatus === 0 && !merchantValue)|| !expenseValue  || (minorSubCategoryOption && minorSubCategoryOption?.length && !minorSubCategoryValue)) {
        setErrors({
          ...errors,
          projectValue:moduleInfo?.typ !== 'Internal' && paymentStatus === 0 ? prJson.required.project : "",
          minorTypeValue:prJson.required.minorType,
          merchantValue:paymentStatus === 0 ?prJson.required.merchant:"",
          expenseValue:prJson.required.majorType,
          clientValue:moduleInfo?.typ !== 'Internal' && paymentStatus === 0 ? prJson.required.clientName:"",
          minorSubCategoryValue:minorSubCategoryOption && minorSubCategoryOption?.length ?  prJson.required.minorSub: ''
        }) 
        addToast(prJson.required.allField, { appearance: "error" });
           return;
         }
    }
     
    const checkApproval = checkApprovalAmount(
      approvalAmount,
    );
    if (!checkApproval.status) {
      setErrors({
        ...errors,
        approvalAmount:checkApproval.msg
      }) 
    return;
    }
   
  
    if(isGst){

      const gstError = gstAmountValidate(
        multipleAddGstInfo,
        taxableAmount
      );
      if (Object.keys(gstError).length !== 0) {
        setGstAmountError(gstError)
        if(activeTab && activeTab !== 'gst'){
          addToast(prJson.error.checkGst , { appearance: "error" });
        }
        return;
      }
    }

    if(isTds){

      const tdsError = tdsAmountValidate(
        multipleTdsInfo,
        taxableAmount
      );
      if (Object.keys(tdsError).length !== 0) {
        setTdsAmountError(tdsError)
        if(activeTab && activeTab !== 'tds'){
          addToast(prJson.error.checkTds , { appearance: "error" });
        }
        return;
      }
    }
    if(isCredit){

      const creditError = addCreditAmountValidate(
        multipleCredit,totalCreditAmount
      );
      if (Object.keys(creditError).length !== 0) {
        setCreditError(creditError)
        if(activeTab && activeTab !== 'credit'){
          addToast(prJson.error.checkCredit , { appearance: "error" });
        }
        return;
      }
      const amount = parseFloat(taxableAmount) - parseFloat(tdsAmount) -  parseFloat(creditAmount);
      if(amount < 0){
        addToast(prJson.error.invalidCredit, { appearance: "error" });
        return;
      }
      if(!creditValid){
        return;
      }
    }

    if(approvalAmount <= totalPaymentAmount && remainingAmount >= 0){
  
      const checkValid = checkTotalApprovedAmountWithSpentAmount(
        totalPaymentAmount,
        multipleAddPaymentInfo
      );
      if (!checkValid.status) {
        setErrors({
          ...errors,
          approvalAmount:checkValid.msg
        })           
        return;
      }
    }
    if(remainingAmount < 0 && approvalAmount <= totalPaymentAmount){
      return;
    }
      let formData = getFormData(values);
      

      formData.append("isCredit", isCredit);
      const filteredMultipleCredit = multipleCredit.filter((item) => item?.usAmt);      
      formData.append("creditInfo", JSON.stringify(filteredMultipleCredit));
      
     setIsLoading(true)

      if(isEdit && editData){
        const gstArray = multipleAddGstInfo.filter(item => {
          if(item?._id){
          return item?._id
        }})
        const tdsArray = multipleTdsInfo.filter(item => {
          if(item?._id){
          return item?._id
        }})
        
          if(multipleAddPaymentInfo?.length && approvalAmount < totalPaymentAmount){
            addToast(prJson.error.spentAmt,{ appearance: "info" });
            setIsLoading(false)
          }
          else if(gstArray?.length && isTaxableAmountMismatch()){
            addToast(`GST record exist! Please remove it.`,{ appearance: "info" });
            setIsLoading(false)
          } else if(tdsArray?.length && isTaxableAmountMismatch()){
            addToast(`TDS record exist! Please remove it.`,{ appearance: "info" });
            setIsLoading(false)
          } else{
              dispatch(fetchAsyncUpdateRequestForTotalPayAmount({ 
                id: editData._id,
                moduleId:moduleInfo?._id,
                formData:formData
            })).then(
          (res) => {
            if (res.payload && res.payload.updatedData) {
              const msg = prJson.confirm.resendRequest.replace("{generatedNum}", generatedNum);
              setPaymentStatus(0)
              addToast(msg, { appearance: "success" });
              setIsLoading(false)
              closeExpenseModal('pending');
            }
            else{
              addToast(res?.error.message, { appearance: "error" });
              setIsLoading(false)
  
            }
          }).catch((err)=>{
            addToast(err.message, { appearance: "error" });
            setIsLoading(false)
          });
          }
        
        
      }
      else{
        dispatch(fetchAsyncSendRequestForTotalPayAmount({moduleId:moduleInfo?._id,formData})).then((res) => {
            if (res.payload) {
              const msg = prJson.confirm.sendRequest.replace("{generatedNum}", generatedNum);
              addToast(msg, { appearance: "success" });
              setPaymentStatus(0)
              setIsLoading(false)
              closeExpenseModal('pending');
            }
            else{
              addToast(res?.error.message, { appearance: "error" });
              setIsLoading(false)
  
            }
          }).catch((err)=>{
            addToast(err.message, { appearance: "error" });
            setIsLoading(false)
          });
      }
      
      }
  const handleTotalPayAmountIsApproved = (values)=>{
    if(isEdit){
  
      if ((moduleInfo?.typ !== 'Internal' && paymentStatus === 0 && !clientValue)  || !minorTypeValue || (moduleInfo?.typ !== 'Internal' && paymentStatus === 0 && !projectValue) || (paymentStatus === 0 && !merchantValue)|| !expenseValue  || (minorSubCategoryOption && minorSubCategoryOption?.length && !minorSubCategoryValue)) {
        setErrors({
          ...errors,
          projectValue:moduleInfo?.typ !== 'Internal' && paymentStatus === 0 ? prJson.required.project : "",
          minorTypeValue:prJson.required.minorType,
          merchantValue:paymentStatus === 0 ?prJson.required.merchant:"",
          expenseValue:prJson.required.majorType,
          clientValue:moduleInfo?.typ !== 'Internal' && paymentStatus === 0 ? prJson.required.clientName:"",
          minorSubCategoryValue:minorSubCategoryOption && minorSubCategoryOption?.length ?  prJson.required.minorSub: ''
        }) 
        addToast(prJson.required.allField, { appearance: "error" });
        return;
         }
    }
    if(parseFloat(creditAmount) > parseFloat(totalCreditAmount)){
      setErrors({
        ...errors,
        creditAmount: prJson.error.creditLimit
      })
    }
    let formData = getFormData(values);
    const _id = editData._id;

    if(isGst){

      const gstError = gstAmountValidate(
        multipleAddGstInfo,
        taxableAmount
      );
      if (Object.keys(gstError).length !== 0) {
        setGstAmountError(gstError)
        if(activeTab && activeTab !== 'gst'){
          addToast(prJson.error.checkGst , { appearance: "error" });
        }
        return;
      }
    }
    if(isTds){
      const tdsError = tdsAmountValidate(
        multipleTdsInfo,
        taxableAmount
      );
      if (Object.keys(tdsError).length !== 0) {
        setTdsAmountError(tdsError)
        if(activeTab && activeTab !== 'tds'){
          addToast(prJson.error.checkTds , { appearance: "error" });
        }
        return;
      }
    }
    if(isCredit){

      const creditError = addCreditAmountValidate(
        multipleCredit,totalCreditAmount
      );
      if (Object.keys(creditError).length !== 0) {
        setCreditError(creditError)
        if(activeTab && activeTab !== 'credit'){
          addToast(prJson.error.checkCredit , { appearance: "error" });
        }
        return;
      }
      const amount = parseFloat(taxableAmount) - parseFloat(tdsAmount) -  parseFloat(creditAmount);

      if(amount < 0){
        addToast(prJson.error.invalidCredit, { appearance: "error" });
        return;
      }
      if(!creditValid){
        return;
      }
    }
     
      formData.append("isCredit", isCredit);
      const filteredMultipleCredit = multipleCredit.filter((item) => item?.usAmt);      
      formData.append("creditInfo", JSON.stringify(filteredMultipleCredit));

      if(editData.pyInfo?.sts === 0){
        const confirmMsg = prJson.confirm.approveAmt;
        const title = confirmMsg.replace("{approvalAmount}", formatAmountIndianRupees(approvalAmount)).replace("{generatedNum}", generatedNum);
        ConfirmationDialog({
          title: title,
          text: prJson.confirm.approveAction,  
          icon: "warning",
          confirmButtonText: "Approve",
          cancelButtonText: "Cancel",
          onConfirm: () => {
            setIsLoading(true)
            dispatch(fetchAsyncApproveTotalPayAmount({ 
              id: _id,
              formData:formData,
              moduleId:moduleInfo?._id
             })).then(
              (res) => {
                if (res.payload && res.payload.updatedData) {
                  const msg = prJson.success.approved.replace("{generatedNum}", generatedNum);
                  addToast(msg, { appearance: "success" });
                  setIsLoading(false)
                  closeExpenseModal('approved');
                }
              }
            );
          }
        })
      }
  }

  const handleTotalPayAmountIsRejected = ()=>{
    const _id = editData._id;
    let formData = new FormData();

    formData.append("isCredit", isCredit);
    const filteredMultipleCredit = multipleCredit.filter((item) => item?.usAmt);      
    formData.append("creditInfo", JSON.stringify(filteredMultipleCredit));
    formData.append("approveRejectRemarks",approveOrRejectRemarks);
    if(editData.pyInfo?.sts === 0 ){
      const confirmMsg = prJson.confirm.rejectAmt;
      const title = confirmMsg.replace("{approvalAmount}", formatAmountIndianRupees(approvalAmount)).replace("{generatedNum}", generatedNum);
      ConfirmationDialog({
        title: title,
        text: prJson.confirm.rejectAction,
        icon: 'warning',
        confirmButtonText: 'Reject',
        cancelButtonText: 'Cancel',
        onConfirm: () => {
          setIsLoading(true)
          dispatch(fetchAsyncRejectTotalPayAmount({ 
            id: _id,
            formData:formData,
            moduleId:moduleInfo?._id
           })).then(
            (res) => {
              if (res.payload && res.payload.updatedData) {
                const msg = prJson.success.rejected.replace("{generatedNum}", generatedNum);
                addToast(msg, { appearance: "success" });
                closeExpenseModal('rejected');
                setIsLoading(false)
              }
            }
          );
        },
      });
    }
  
  }


  const [remainingTds,setRemainingTds] = useState(0)
  useEffect(()=>{
    if(multipleTdsInfo) {
      const array = multipleTdsInfo;

        const sum = array.reduce((acc, current) => {
          if (current?.bsAmt && current?.bsAmt !== '') {
            return acc + parseFloat(current?.bsAmt);
          } else {
            return acc;
          }
        }, 0);

        const remaining = parseFloat(taxableAmount || 0) - parseFloat(sum || 0)

        setRemainingTds(parseFloat(remaining.toFixed(2)))
      
    }
  },[multipleTdsInfo])


  useEffect(()=>{
    if(!isTds){

      setAmountTotal(0)
      setTdsAmount(0)
      // setTdsPercent(10)
      setIsTds(false)

    }
  },[isTds])

 
  useEffect(()=>{
    if(isGst && !multipleAddGstInfo?.length && !editData?.gstApl?.gstId){
      setMultipleAddGstInfo([""])
    } else if(isGst && editData?.pyInfo.sts !== 1 && !editData?.gstApl?.gstId){
      setMultipleAddGstInfo([""])
    }
  },[isGst])
 
  const closeModelForm = () => {
    ConfirmationDialog({
      title: commonJson.close.confirm,
      text: commonJson.text.lost,
      icon: 'warning',
      confirmButtonText: 'Close',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        closeExpenseModal();
      },
    });
  };

  const handleRemarksChange = (e)=>{
    const value = e?.target?.value;
    const encoder = new TextEncoder(); 
    const byteLength = encoder.encode(value).length;
    if(byteLength <=128){
      setRemarksValue(value)
      setErrors({
        ...errors,
        remarks:''
      })
    }
    else{
      setErrors({
        ...errors,
        remarks:prJson.error.remarksLimit
      })
    }
  }

  const deleteMultipleListItem = (listIndex)=>{
    ConfirmationDialog({
      title: prJson.confirm.deleteAmt,
      text: '',
      icon: 'warning',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        const sendData = {
          id: editData._id,
          moduleId:moduleInfo?._id,
          listIndex:listIndex
        };
        dispatch(fetchAsyncDeletePaymentListItem(sendData)).then((res) => {
          if(res?.payload?.customExpense?.pyInfo?.list && res?.payload?.customExpense?.pyInfo?.list?.length){
            setMultipleAddPaymentInfo(res?.payload?.customExpense?.pyInfo?.list)
          }
          else{
            setMultipleAddPaymentInfo(prevState => prevState.filter((_, i) => i !== listIndex));
          }
          addToast(prJson.success.spentAmt, { appearance: "success" });
        });
      },
    });
   
}

const deleteMultipleRefundListItem = (listIndex)=>{
  ConfirmationDialog({
    title: prJson.confirm.deleteRefundAmt,
    text: '',
    icon: 'warning',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
    onConfirm: () => {
      const sendData = {
        id: editData._id,
        moduleId:moduleInfo?._id,
        listIndex:listIndex
      };
      dispatch(fetchAsyncDeleteRefundListItem(sendData)).then((res) => {
        if(res?.payload?.customExpense?.rfdInfo?.list && res?.payload?.customExpense?.rfdInfo?.list?.length){
          setMultipleAddRefundInfo(res?.payload?.customExpense?.rfdInfo?.list)
          if(!res?.payload?.customExpense?.rfdInfo?.list?.length){
            setIsRefund(false)
          }
        }
        else{
          setMultipleAddRefundInfo(prevState => prevState.filter((_, i) => i !== listIndex));
        }
        addToast(prJson.success.deleteRefund, { appearance: "success" });
      });
    },
  });
}
const deleteMultipleTdsListItem = (listIndex)=>{
  ConfirmationDialog({
    title: `Are you sure? Delete Tds Amount Details Permanently?`,
    text: '',
    icon: 'warning',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
    onConfirm: () => {
      const sendData = {
        id: editData?._id,
        moduleId:moduleInfo?._id,
        listIndex:listIndex
      };
      dispatch(fetchAsyncDeleteTdsListItem(sendData)).then((res) => {
        if(res?.payload?.customExpense?.tdsApl?.list && res?.payload?.customExpense?.tdsApl?.list?.length){
          setMultipleTdsInfo(res?.payload?.customExpense?.tdsApl?.list)
        }
        else{
          setMultipleTdsInfo(prevState => prevState.filter((_, i) => i !== listIndex));
        }
        addToast(`Tds Amount details deleted successfully!`, { appearance: "success" });
      });
    },
  });
}

const hasAccess = useCallback(() => {
  return (role === "Admin" || role === "Manager" || role === 'Accountant') && paymentStatus === 1;
}, [role, paymentStatus]);

const isTaxableAmountMismatch = useCallback(() => {
  const editTaxableAmount = editData?.pyInfo?.txAmt || 0;
  return parseFloat(taxableAmount || 0) !== parseFloat(editTaxableAmount);
}, [taxableAmount, editData]);


const isTDSPoGenerated = useCallback(() => {
  const isTDSPO = editData?.tdsApl?.tdsPo?.sts;
  const tdsId = editData?.tdsApl?.tdsPo?.poNo?._id;
  return isTDSPO && tdsId;

}, [editData,generatedTDSpoNum]);

const isCreditAmountMismatch = useCallback(() => {
  return creditAmountMismatch(multipleCredit,editData);
}, [multipleCredit, editData]);

const isSendRequest = useCallback(() => {
  const isPending = paymentStatus === 0;
  const isTdsPOGenerated = isTDSPoGenerated();
  return ( isTaxableAmountMismatch() || isCreditAmountMismatch() || isPending) && !isTdsPOGenerated;
}, [ editData, isTaxableAmountMismatch,isTDSPoGenerated,isCreditAmountMismatch]);


const fetchTDSData = (editData) => {
  if (editData?._id) {
    dispatch(fetchAsyncGetTDSExpenseByRefrencePO(editData?._id)).then((res) => {
      const tdsData = res?.payload?.tdsExpense;
      if (res?.payload && tdsData) {
        if (tdsData?.rfPo) {
          setIsTds(editData.tdsApl?.sts);
          setAmountTotal(tdsData?.tlBlAmt);
          setTdsAmount(tdsData?.tdsAmt);
          setIsGenerateTDSPo(true);
          setGeneratedTDSpoNum(poNumberFormate(tdsData?.poNo));
        }
        setFullTdsData(tdsData);
      } else {
        if (editData.tdsApl?.sts) {
          setIsTds(editData.tdsApl?.sts);
          editData.tdsApl?.bsAmt && setAmountTotal(editData.tdsApl?.bsAmt);
          editData.tdsApl?.tlAmt && setTdsAmount(editData.tdsApl?.tlAmt);
        } else {
          setAmountTotal(editData.tdsApl?.tlAmt);
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
};

const updatedApprovalAmount = ()=>{

  const gstArray = multipleAddGstInfo.map(item => {
    if (item?.gstFullData) {
        return item?.gstFullData; 
    } if(item?._id){
      return item?._id
    } else {
        return { amt: {} }; 
    }
});  
const totalGst = calculateTotalGst(gstArray)
let totalRequestedAmt = parseFloat(taxableAmount) + parseFloat(totalGst)
setApprovalAmount(totalRequestedAmt + roundOfAmount)
}

useEffect(()=>{
  updatedApprovalAmount();
},[roundOfAmount])

useEffect(()=>{
  setTotalPaymentAmount(Number(approvalAmount))
},[approvalAmount])
useEffect(()=>{
 
    if(taxableAmount && (isTaxableAmountMismatch() || paymentStatus !== 1) &&  multipleAddGstInfo && multipleAddGstInfo?.length > 0){
      updatedApprovalAmount();
    }
    else if(isTaxableAmountMismatch()){

        if(multipleAddGstInfo && multipleAddGstInfo?.length > 0){
          updatedApprovalAmount();
  
        }else{
  
          setApprovalAmount(taxableAmount + roundOfAmount)
        }
      
    }
    else{
      setApprovalAmount(editData?.pyInfo?.apAmt)
      // setMultipleAddGstInfo([""])
    }
   
     
      if(totalPaymentAmount && editData?.tdsApl?.tlAmt && isTds){
        fetchTDSData(editData);
      }
    
},[
  isTaxableAmountMismatch,
  multipleAddGstInfo,
  isTds,
  isGst,
  isTDSPoGenerated
])

const updateCreditOptions = async()=>{
  const creditIds = multipleCredit.map((item)=>{
    if(item?.crId){
      return item?.crId?._id
    }
    else{
      return item?._id;
    }
  })
  const creditList = allCreditData.filter((item)=> !creditIds.includes(item?._id))
  const creditOption = await clientProjectOptions('coNo','_id',creditList) 

  setAllCreditOptions(creditOption)
}
useEffect(()=>{
  if(multipleCredit){
    const sumOfCredit = calculateTotalCredit(multipleCredit)
    setCreditAmount(sumOfCredit)
    updateCreditOptions();
  }
},[multipleCredit,allCreditData])

const handleToggleGenerateTDSPo = () => {
  if (isGenerateTDSPo) {
    setIsGenerateTDSPo(false);
  } else {
    const title = prJson.confirm.genTdsPo.replace("{amountTotal}", formatAmountIndianRupees(amountTotal));

    ConfirmationDialog({
      title: title,
      text: prJson.text.undoneTdsPo,
      icon: 'warning',
      confirmButtonText: 'Generate',
      cancelButtonText: 'Cancel',
      onConfirm: () => setIsGenerateTDSPo(true),
    });
  }
};

const handleToggleGstApplicable = () => {
  const gstArray = multipleAddGstInfo.filter(item => {
    if(item?._id){
    return item?._id
  } 
  });
  if (gstArray?.length) {
    addToast(`first for delete existing gst records!`,{ appearance: "info" });
  } else {
    setIsGst(!isGst)
    if(!multipleAddGstInfo?.length){
      setMultipleAddGstInfo([""])
    }
  }
};

const handleToggleCreditApplicable = () => {

      if(!merchantValue){
        addToast(prJson.required.merchant,{ appearance: "error" });
      }
      else{
        if(!multipleCredit.length){
          if (allCreditData.length > 0) {
            setIsCredit(!isCredit)
            const firstItem = allCreditData[0];
            const availableCredit =
              parseFloat(firstItem?.amt || 0) -
              parseFloat(firstItem?.usAmt || 0) -
              parseFloat(firstItem?.resAmt || 0);

            const remainingPayable = Math.max(remainingAmount, 0);

            const defaultCredit = Math.min(availableCredit, remainingPayable);
            const obj = {
              ...firstItem,
              usAmt:defaultCredit
            }
            setMultipleCredit([obj]); 
          }
          else{
            addToast(prJson.error.avalCredit, { appearance: "error" });
          }  
      }
      else{
        addToast(prJson.info.deleteCredit,{ appearance: "info" });
      }
    }
};

const handleToggleRefundApplicable = () => {
 
    setIsRefund(!isRefund)
    if(!multipleAddRefundInfo?.length){
      setMultipleAddRefundInfo([""])
    }
  
};

const handleToggleTDSApplicable = () => {
  const tdsArray = multipleTdsInfo.filter(item => {
    if(item?._id){
    return item?._id
  } 
})
  if (tdsArray?.length) {
    addToast(`first for delete existing tds records!`,{ appearance: "info" });
  } else {
    setIsTds(!isTds)
    if(!multipleTdsInfo?.length){
      setMultipleTdsInfo([""])
    }
  }
};

const handleSelectTab = (k) => {
  setActiveTab(k);
};

const getTotalCreditAmount = async(vendorId)=>{
  await dispatch(fetchAsyncGetTotalCreditAmount(vendorId)).then((res)=>{

    if(res?.payload){
      const total = res?.payload?.totalAmount;
      setTotalCreditAmount(total)
      
    }
    }).catch((err)=>{
      addToast(prJson.error.fetchCredit,{ appearance: "error" });

    })
}
const getAllCreditByVendorID = async(vendorId)=>{
  try {
      const res = await dispatch(fetchAsyncGetCreditOptionsByVendorId(vendorId)); 
      if (res?.payload) {
        const creditDetail = res?.payload?.filterCredit;
        const filterCredit = creditDetail?.map((item)=>{
          return {
            ...item,
            coNo:poNumberFormate(item?.crNo)
          }
        })
        const creditOption = await clientProjectOptions('coNo','_id',filterCredit) 
        setAllCreditData(filterCredit)
        setAllCreditOptions(creditOption);
        setIsLoading(false)
        if(!isEdit){
          setMultipleCredit([]);
          setIsCredit(false)
        }
      }
    } catch (error) {
      setIsLoading(false)
      addToast(prJson.error.fetchCredit, { appearance: "error" });
    }
}

const handleAddCredit = (newValue)=>{
  const creditId = newValue?.value;
  const newItem = allCreditData.find(item=>item._id === creditId);

  const availableCredit =
    parseFloat(newItem?.amt || 0) -
    parseFloat(newItem?.usAmt || 0) -
    parseFloat(newItem?.resAmt || 0);

  const remainingPayable = Math.max(remainingAmount, 0);

  const defaultCredit = Math.min(
    availableCredit,
    remainingPayable
  );
  const obj = {
    ...newItem,
    usAmt:defaultCredit
  }
  setMultipleCredit([...multipleCredit,obj]); 
  setAddCredit(!addCredit)
}

const validateCredits = useCallback(() => {
  return isValidateCredit(multipleCredit,editData)
}, [multipleCredit]);


const handleDeleteCredit = (id,creditId)=>{
  ConfirmationDialog({
    title: prJson.confirm.deleteCredit,
    text: '',
    icon: 'warning',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
    onConfirm: () => {
      if(creditId && creditId?._id){
        const data = {
          creditId:id,
          moduleId:moduleInfo?._id,
          expenseId:editData?._id,
          status: paymentStatus === 1 ? 'approved' : 'pending',
          expenseType:{expenseType}
        }
        dispatch(fetchAsyncDeleteCreditListItem(data)).then((res) => {
          if(res?.payload){
            refreshEditData();
            const filterCredit = multipleCredit.filter(item=>item?.crId?._id !== id);
            setMultipleCredit(filterCredit); 
            if(filterCredit.length === 0){
              setIsCredit(!isCredit)
            }
            addToast(prJson.success.deletedCredit, { appearance: "success" });
            setIsLoading(false)
            const vendorId = merchantValue.value;
            getTotalCreditAmount(vendorId);
            getAllCreditByVendorID(vendorId)
          }
          else{
            addToast(prJson.faield.deleteCredit, { appearance: "error" });
          }
        }).catch((err)=>{
          addToast(prJson.faield.deleteCredit, { appearance: "error" });

        })
      }
      else{

        const filterCredit = multipleCredit.filter(item=>item._id !== id);
        setMultipleCredit(filterCredit); 
        if(filterCredit.length === 0){
          setIsCredit(!isCredit)
        }
        setIsLoading(false)
        addToast(prJson.success.deletedCredit, { appearance: "success" });
        const vendorId = merchantValue.value;
        getTotalCreditAmount(vendorId);
        getAllCreditByVendorID(vendorId)
      }
     
    },
  });
}

useEffect(()=>{
  const amount = parseFloat(taxableAmount) - parseFloat(tdsAmount) -  parseFloat(creditAmount);
  if(amount < 0){
    setErrors({
      ...errors,
      taxableAmount:prJson.error.invalidCredit
    })
  }
  else{
    setErrors({
      ...errors,
      taxableAmount:''
    })
  }

},[taxableAmount,creditAmount,tdsAmount])

useEffect(()=>{
  if(merchantValue.value){
    const vendorId = merchantValue.value;
    getTotalCreditAmount(vendorId);
    getAllCreditByVendorID(vendorId)
    dispatch(fetchAsyncGetVendorByID(vendorId)).then((res)=>{
  
      if(res?.payload){
        const {pnNo} = res?.payload?.vendor;  
        setPanNumber(pnNo)
      }
      }).catch((err)=>{
        console.log(err)
      })
    }
  
},[merchantValue])

const handleAddAmount = (amt)=>{
  const parsedAmount = parseFloat(amt);
  if (!isNaN(parsedAmount)) {
    setRoundOfAmount(parsedAmount)
  }
}


const isAddGstButtonVisible = useCallback(() => {
  const gstArray = extractGstData(multipleAddGstInfo);
  const totalBaseAmount = calculateTotalBaseAmount(gstArray,taxableAmount);

  if(!totalBaseAmount){
    return true;
  }
  if(Number(totalBaseAmount) > Number(taxableAmount)){
    return true;
  }
  else{

    return isGst && taxableAmount && totalBaseAmount && Number(taxableAmount) <= Number(totalBaseAmount);
  }
}, [multipleAddGstInfo, taxableAmount, isGst]);

const isAddTdsButtonVisible = useCallback(() => {
  const totalBaseAmount = calculateTdsBaseAmount(multipleTdsInfo)

  if(!totalBaseAmount){
    return true;
  }
  if(Number(totalBaseAmount) > Number(taxableAmount)){
    return true;
  }
  else{
    return isTds && taxableAmount && totalBaseAmount && Number(taxableAmount) <= Number(totalBaseAmount) && !isTDSPoGenerated();
  }
}, [multipleTdsInfo, taxableAmount, isTds,isTDSPoGenerated]);



const handleTdsAmount = (amount,baseAmount)=>{
  if(isTds){
    setTdsAmount(amount);
    setAmountTotal(baseAmount)

  }
}

useEffect(()=>{
  if(isTds && multipleTdsInfo && multipleTdsInfo?.length > 0){
  const totalTds = calculateTdsAmount(multipleTdsInfo)
  const totalBaseAmount = calculateTdsBaseAmount(multipleTdsInfo)

  handleTdsAmount(totalTds,totalBaseAmount)
  }
  
},[isTds,multipleTdsInfo])

  const handleUpdateClientValue = useCallback((newValue) => {
    setClientValue(newValue)
    getAllProjectOptions(newValue?.value)
  }, []);

  const handleProjectChange = (newValue) => {
    if (role === 'Accountant') {
      const associatedClient = clientData?.find(c => c.prjs?.some(p => p._id === newValue?.value));
      if (associatedClient?._id) {
        setClientValue(clientOPtion?.find(o => o.value === associatedClient._id))
        setProjectValue(newValue);
      }
    } else {
      setProjectValue(newValue);
    }
  }
  
  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={openExpenseModal}
        onClose={() => closeModelForm()}
        size="xl"
        className="modal-main"
      >
        <ModalOverlay />
        <ModalContent
          top="0"
          margin="0 auto"
          bottom="0"
          className="add-form-modal-content"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              {moduleInfo?.name} -{" "}
              <span className="header-pr">{generatedNum}</span>
            </ModalHeader>
            <ModalCloseButton />
          </div>
          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <ModalBody>
              <Form className="addForm" onSubmit={formik.handleSubmit}>
                <div className="form-card">
                  <h5 className="mt-0">Purchase Order Details</h5>
                  <Row className="mt-2">
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Order Number <span className="span-star">*</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          name="poNo"
                          placeholder="No"
                          value={generatedNum && generatedNum}
                          disabled
                        />
                      </Box>
                    </Col>

                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Order - Month <span className="span-star">*</span>
                        </Form.Label>
                        <Box>
                          <DatePicker
                            className={`monthDate ${
                              isBlink ? "month_blink active" : ""
                            }`}
                            dateFormat="MM-yyyy"
                            showMonthYearPicker
                            name="orderMonth"
                            onChange={(e) => {
                              const dateTime = moment(e).format("yyyy-MM");
                              setGetPoMonth(dateTime);
                            }}
                            disabled={isEdit}
                            // defaultValue={new Date()}
                            selected={
                              getPoMonth ? new Date(moment(getPoMonth)) : ""
                            }
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        </Box>
                      </Box>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Order Date <span className="span-star">*</span>
                        </Form.Label>
                        <Box>
                          <DatePicker
                            name="orderDate"
                            className={`monthDate ${
                              isBlink ? "date_blink active" : ""
                            }`}
                            dateFormat="dd-MMM-yyyy"
                            // disabled={isEdit}
                            onChange={(date) => {
                              setSelectedDate(date);
                            }}
                            selected={selectedDate}
                            minDate={startOfMonth}
                            maxDate={endOfMonth}
                            showMonthDropdown={false}
                            showYearDropdown={false}
                            dropdownMode="select"
                          />
                        </Box>
                      </Box>
                    </Col>
                    <Col></Col>
                  </Row>
                  {moduleInfo?.typ === "Resource" && (
                    <Row>
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Resource Name <span className="span-star">*</span>
                          </Form.Label>
                          <div
                            className="merchant-field"
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                          >
                            <ClientProjectSelect
                              options={resourceOption}
                              placeHolder={<div>Type or select...</div>}
                              onChange={(newValue) => {
                                setMerchantValue(newValue);
                                setIsHovered(false);
                              }}
                              isSearchable
                              defaultValue={merchantValue}
                              role={role}
                              isDisabled={
                                multipleCredit?.length && paymentStatus === 0
                              }
                              name="merchnatName"
                            />
                            {merchantValue?.value &&
                            totalCreditAmount &&
                            isHovered ? (
                              <Form.Text className="text-muted credit-amount-popover">
                                <Box className="" display="flex">
                                  <Box className="credit-amount-tag">
                                    {formatAmountInINR(totalCreditAmount || 0)}
                                  </Box>
                                </Box>
                              </Form.Text>
                            ) : (
                              ""
                            )}
                          </div>
                        </Box>

                        {errors?.merchantValue && !merchantValue && (
                          <p className="form_error">{errors?.resourceValue}</p>
                        )}
                      </Col>
                      <Col>
                        <PanNumberField
                          panNumber={panNumber}
                          handlePanNumber={(pan) => setPanNumber(pan)}
                          totalPayAmount={totalPayAmountByPanNumber}
                          role={role}
                        />
                      </Col>
                    </Row>
                  )}
                </div>
                <div className="form-card mt-3">
                  <h5>Expense</h5>
                  {moduleInfo?.typ === "Internal" && (
                    <Row>
                      <Col className="custom-select">
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Office Type <span className="span-star">*</span>
                          </Form.Label>

                          <CustomSelect
                            options={officeTypOption}
                            placeHolder={<div>Type or select...</div>}
                            onChange={(newValue) =>
                              setOfficeTypeValue(newValue)
                            }
                            isSearchable
                            onCreateOption={(e) => {
                              createNewFormOption(
                                createOption(e),
                                "office-type"
                              );
                            }}
                            onDeleteOption={(option) => {
                              deleteFromOption(option, "office-type");
                            }}
                            onEditOption={(option, newValue) => {
                              editFromOption(option, newValue, "office-type");
                            }}
                            defaultValue={officeTypeValue}
                            role={role}
                            isInvalid={
                              errors?.officeTypeValue && !officeTypeValue
                            }
                          />
                        </Box>
                        {errors?.officeTypeValue && !officeTypeValue && (
                          <p className="form_error">
                            {errors?.officeTypeValue}
                          </p>
                        )}
                      </Col>
                      <Col></Col>
                    </Row>
                  )}
                  <Row>
                    <Col className="custom-select">
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Major Type <span className="span-star">*</span>
                        </Form.Label>

                        <CustomSelect
                          options={expenseOption}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) => setExpenseValue(newValue)}
                          isSearchable
                          onCreateOption={(e) => {
                            createNewFormOption(createOption(e), "expense");
                          }}
                          onDeleteOption={(option) => {
                            deleteFromOption(option, "expense");
                          }}
                          onEditOption={(option, newValue) => {
                            editFromOption(option, newValue, "expense");
                          }}
                          defaultValue={expenseValue}
                          role={role}
                          isInvalid={errors?.expenseValue && !expenseValue}
                        />
                      </Box>
                      {errors?.expenseValue && !expenseValue && (
                        <p className="form_error">{errors?.expenseValue}</p>
                      )}
                    </Col>
                    {expenseValue ? (
                      <Col className="custom-select">
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Minor Type <span className="span-star">*</span>
                          </Form.Label>

                          <CustomSelect
                            options={minorTypeOption}
                            placeHolder={<div>Type or select...</div>}
                            onChange={(newValue) => setMinorTypeValue(newValue)}
                            isSearchable
                            onCreateOption={(e) => {
                              if (expenseValue?.value) {
                                createSubCategory(
                                  createOption(e),
                                  expenseValue
                                );
                              } else {
                                addToast("Please Select Major Type", {
                                  appearance: "error",
                                });
                              }
                            }}
                            onDeleteOption={(option) => {
                              deleteSubCategory(option);
                            }}
                            onEditOption={(option, newValue) => {
                              editSubCategory(option, newValue);
                            }}
                            defaultValue={minorTypeValue}
                            role={role}
                            isInvalid={
                              errors?.minorTypeValue && !minorTypeValue
                            }
                          />
                        </Box>
                        {errors?.minorTypeValue && !minorTypeValue && (
                          <p className="form_error">{errors?.minorTypeValue}</p>
                        )}
                      </Col>
                    ) : (
                      <Col></Col>
                    )}
                  </Row>
                  {minorTypeValue && (
                    <Row>
                      <Col className="custom-select">
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Minor Sub Category{" "}
                            <span className="span-star">
                              {minorSubCategoryOption &&
                              minorSubCategoryOption?.length
                                ? "*"
                                : ""}
                            </span>
                          </Form.Label>

                          <CustomSelect
                            options={minorSubCategoryOption}
                            placeHolder={<div>Type or select...</div>}
                            onChange={(newValue) =>
                              setMinorSubCategoryValue(newValue)
                            }
                            isSearchable
                            onCreateOption={(e) => {
                              if (minorTypeValue?.value) {
                                createMinorSubCategory(
                                  createOption(e),
                                  minorTypeValue
                                );
                              } else {
                                addToast("Please Select Minor Type", {
                                  appearance: "error",
                                });
                              }
                            }}
                            onDeleteOption={(option) => {
                              deleteMinorSubCategory(option);
                            }}
                            onEditOption={(option, newValue) => {
                              editMinorSubCategory(option, newValue);
                            }}
                            defaultValue={minorSubCategoryValue}
                            role={role}
                            isInvalid={
                              errors?.minorSubCategoryValue &&
                              !minorSubCategoryValue
                            }
                          />
                        </Box>
                        {errors?.minorSubCategoryValue &&
                          !minorSubCategoryValue && (
                            <p className="form_error">
                              {errors?.minorSubCategoryValue}
                            </p>
                          )}
                      </Col>
                      {moduleInfo?.typ !== "Resource" ? (
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>
                              Merchant Name{" "}
                              {paymentStatus === 0 && (
                                <span className="span-star">*</span>
                              )}
                              {""}
                            </Form.Label>
                            <div
                              className="merchant-field"
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                            >
                              <ClientProjectSelect
                                options={merchantOption}
                                placeHolder={<div>Type or select...</div>}
                                onChange={(newValue) => {
                                  setMerchantValue(newValue);
                                  setIsHovered(false);
                                }}
                                isSearchable
                                defaultValue={merchantValue}
                                role={role}
                                isDisabled={
                                  multipleCredit?.length && paymentStatus === 0
                                }
                                name="merchnatName"
                              />
                              {merchantValue?.value &&
                              totalCreditAmount &&
                              isHovered ? (
                                <Form.Text className="text-muted credit-amount-popover">
                                  <Box className="" display="flex">
                                    <Box className="credit-amount-tag">
                                      {formatAmountInINR(
                                        totalCreditAmount || 0
                                      )}
                                    </Box>
                                  </Box>
                                </Form.Text>
                              ) : (
                                ""
                              )}
                            </div>
                          </Box>

                          {errors?.merchantValue && !merchantValue && (
                            <p className="form_error">
                              {errors?.merchantValue}
                            </p>
                          )}
                        </Col>
                      ) : (
                        <Col></Col>
                      )}
                    </Row>
                  )}
                  {minorTypeValue && moduleInfo?.typ !== "Internal" && (
                    <>
                      <Row>
                        {role !== 'Accountant' && <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>
                              Client Name{" "}
                              {paymentStatus === 0 && (
                                <span className="span-star">*</span>
                              )}
                            </Form.Label>

                            <ClientProjectSelect
                              options={clientOPtion}
                              placeHolder={<div>Type or select...</div>}
                              onChange={(newValue) => role !== 'Accountant' && handleUpdateClientValue(newValue)}
                              isSearchable
                              defaultValue={clientValue}
                              role={role}
                              isInvalid={errors?.clientValue && !clientValue}
                            />
                          </Box>
                          {errors?.clientValue && !clientValue && (
                            <p className="form_error">{errors?.clientValue}</p>
                          )}
                        </Col>}
                          <Col className="custom-select">
                            <Box display="flex" className="input-box">
                              <Form.Label>
                                Project Name{" "}
                                <span className="span-star">*</span>
                              </Form.Label>

                              <ClientProjectSelect
                                options={projectOption}
                                placeHolder={<div>Type or select...</div>}
                                onChange={(newValue) =>
                                  handleProjectChange(newValue)
                                }
                                isSearchable
                                defaultValue={projectValue}
                                role={role}
                                isInvalid={
                                  errors?.projectValue && !projectValue
                                }
                              />
                            </Box>
                            {errors?.projectValue && !projectValue && (
                              <p className="form_error">
                                {errors?.projectValue}
                              </p>
                            )}
                          </Col>
                          {role === 'Accountant' && <Col />}
                      </Row>
                    </>
                  )}

                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Remarks </Form.Label>
                        <TextAreaField
                          name="remarks"
                          value={remarksValue}
                          handleChange={(e) => handleRemarksChange(e)}
                          isInvalid={!!errors?.remarks}
                        />
                       
                      </Box>
                    </Col>
                    <p className="form_error">{errors?.remarks}</p>
                  </Row>
                </div>
                <div className="form-card mt-3">
                  <Box display="flex" className="payment-info-box">
                    <h5>Payment Information</h5>
                  </Box>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Taxable Amount <span className="span-star">*</span>
                        </Form.Label>

                        <InputGroup className="input-group">
                          <InputGroup.Text>
                            <span className="rupee-symbol">₹</span>{" "}
                          </InputGroup.Text>
                          <CurrencyFormat
                            customInput={Form.Control}
                            className="amount-input"
                            type="text"
                            onValueChange={(e) => {
                              setTaxableAmount(e.value);
                            }}
                            name="taxableAmount"
                            value={taxableAmount}
                            disabled={isTDSPoGenerated()}
                            placeholder="0.00"
                            thousandSeparator={true}
                            // prefix={"$"}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            isInvalid={
                              (creditAmount && !taxableAmount) ||
                              errors?.taxableAmount
                            }
                          />
                        </InputGroup>
                      </Box>
                    </Col>

                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Requested Amount <span className="span-star">*</span>
                        </Form.Label>
                        <InputGroup className="input-group">
                          <InputGroup.Text>
                            <span className="rupee-symbol">₹</span>{" "}
                          </InputGroup.Text>
                          <CurrencyFormat
                            customInput={Form.Control}
                            className="amount-input"
                            type="text"
                            disabled
                            name="approvalAmount"
                            placeholder="Requested Amount"
                            value={approvalAmount || 0}
                            onValueChange={(e) => {
                              setApprovalAmount(e.value);
                            }}
                            isInvalid={
                              (remainingAmount < 0 &&
                                approvalAmount <= totalPaymentAmount) ||
                              (!approvalAmount && errors?.approvalAmount)
                            }
                            thousandSeparator={true}
                            // prefix={"$"}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                          <InputGroup.Text className="quotation-upload">
                            {approvalAmount ? (
                              <div className="add-amoun-button">
                                <AmountPopover
                                  roundOfAmount={roundOfAmount}
                                  addAmount={(value) => {
                                    handleAddAmount(value);
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            <Tooltip
                              label="Upload Quotation"
                              fontSize="md"
                              borderRadius="2xl"
                            >
                              <div
                                disabled={!approvalAmount}
                                className="position-relative"
                                onClick={() => {
                                  approvalAmount &&
                                    setOpenQuotation(!openQuotation);
                                }}
                              >
                                <FaFileUpload size={20} />
                                <span className="position-absolute top-0 start-100 translate-middle badge  bg-primary text-white">
                                  {quotationData?.files ||
                                  quotationData?.remarks
                                    ? allQuotation?.length + 1
                                    : allQuotation?.length || 0}
                                </span>
                              </div>
                            </Tooltip>
                          </InputGroup.Text>
                        </InputGroup>
                      </Box>
                      {((remainingAmount < 0 &&
                        approvalAmount <= totalPaymentAmount) ||
                        !approvalAmount) && (
                        <p className="form_error">{errors?.approvalAmount}</p>
                      )}
                    </Col>
                  </Row>

                  {paymentStatus === 1 && (
                    <>
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Approved Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">₹</span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                className="amount-input"
                                type="text"
                                disabled
                                name="totalPayAmount"
                                placeholder="Total Amount"
                                value={
                                  totalPaymentAmount ? totalPaymentAmount : 0
                                }
                                thousandSeparator={true}
                                // prefix={"$"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                        </Col>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Credit Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">₹</span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                className="amount-input"
                                type="text"
                                disabled
                                name="creditAmount"
                                placeholder="Credit Amount"
                                value={creditAmount || 0}
                                thousandSeparator={true}
                                // prefix={"$"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Net Payable Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">₹</span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                type="text"
                                className="amount-input"
                                disabled
                                name="Net Payable Amount"
                                value={remainingAmount ? remainingAmount : 0}
                                thousandSeparator={true}
                                decimalScale={2}
                                isInvalid={
                                  remainingAmount < 0 &&
                                  approvalAmount <= totalPaymentAmount
                                }
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                          {remainingAmount < 0 &&
                            approvalAmount <= totalPaymentAmount && (
                              <p className="form_error">
                                Net payable amount cannot be negative. Please
                                revise the request with an increased requested
                                amount and resubmit for approval.
                              </p>
                            )}
                        </Col>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Total Spent Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">₹</span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                type="text"
                                disabled
                                className="amount-input"
                                name="totalPayAmount"
                                placeholder="Total Amount"
                                value={totalSpentAmount}
                                thousandSeparator={true}
                                // prefix={"$"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                        </Col>
                      </Row>
                    </>
                  )}

                  {paymentStatus !== 1 && (
                    <Row>
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>Credit Amount</Form.Label>
                          <InputGroup className="input-group">
                            <InputGroup.Text>
                              <span className="rupee-symbol">₹</span>{" "}
                            </InputGroup.Text>
                            <CurrencyFormat
                              customInput={Form.Control}
                              className="amount-input"
                              type="text"
                              disabled
                              name="creditAmount"
                              placeholder="Credit Amount"
                              value={creditAmount || ""}
                              thousandSeparator={true}
                              // prefix={"$"}
                              decimalScale={2}
                              fixedDecimalScale={true}
                            />
                          </InputGroup>
                        </Box>
                      </Col>
                      <Col></Col>
                    </Row>
                  )}
                </div>

                <div>
                  <Tabs
                    defaultActiveKey={
                      activeTab
                        ? activeTab
                        : paymentStatus === 1
                        ? "spent"
                        : "gst"
                    }
                    transition={false}
                    id="noanim-tab-example"
                    className="add-form-tabs expense-tabs"
                    onSelect={handleSelectTab}
                  >
                    {paymentStatus === 1 && (
                      <Tab
                        eventKey="spent"
                        title="Spent Amount"
                        className="add-form-tab mx-0"
                      >
                        <div className="form-card">
                          {paymentStatus === 1 &&
                            multipleAddPaymentInfo?.length > 0 &&
                            multipleAddPaymentInfo.map((item, index) => {
                              return (
                                <PaymentInfoComponent
                                  key={`payment-info-${index}`}
                                  getData={(data) => {
                                    handleUpdateMultiplePayData(data, index);
                                  }}
                                  autoCount={index}
                                  paymentData={item}
                                  editData={editData}
                                  refreshEditData={refreshEditData}
                                  isEdit={isEdit}
                                  remainingAmount={remainingAmount}
                                  spentAmountError={spentAmountError}
                                  deleteMultipleListItem={() =>
                                    deleteMultipleListItem(index)
                                  }
                                  role={role}
                                  expenseType={expenseType}
                                  merchantValue={merchantValue}
                                  moduleInfo={moduleInfo}
                                />
                              );
                            })}
                          <Box display="flex" alignItems="center">
                            <h5>Add Spent Amount</h5>

                            <Button
                              className="add-project mt-2 mx-1"
                              minWidth={0}
                              disabled={!remainingAmount}
                              onClick={() => {
                                handleMultiplePayInfo(
                                  multipleAddPaymentInfo.length + 1
                                );
                              }}
                            >
                              <FaPlusCircle
                                className="add-project-icon"
                                size={15}
                              />
                            </Button>
                          </Box>
                        </div>
                      </Tab>
                    )}
                     {hasAccess() &&
                    <Tab
                      eventKey="Invoices"
                      title={
                        <div className="d-flex ">
                          Invoices
                          {multipleInvoiceData && multipleInvoiceData?.length > 0 && <FaCheck size={12} className="tab-icon" />}
                        </div>
                      }
                      className="add-form-tab"
                    >
                      {activeTab === 'Invoices' &&
                      <div className="form-card">
                        <Row>
                          <Col>
                            <Box display="flex" className="input-box">
                              <Form.Label className="bill-number">
                                Bill Number #
                              </Form.Label>

                              <Box>
                                <Form.Control
                                  type="text"
                                  name="billNumber"
                                  placeholder="Bill Number"
                                  onChange={(e) => {
                                    setBillNumber(e.target.value);
                                  }}
                                  value={billNumber}
                                />
                              </Box>
                            </Box>
                          </Col>
                          <Col></Col>
                        </Row>
                        <div
                          className="form-card"
                          style={{ marginBottom: "0px" }}
                        >
                          <Box display="flex" alignItems="center">
                            <h5>Invoice</h5>
                            <Button
                              className="add-project mt-1"
                              onClick={() => {
                                handleInvoiceChange();
                              }}
                            >
                              <FaPlusCircle
                                className="add-project-icon"
                                size={15}
                              />
                            </Button>
                          </Box>
                          <Box display="flex">
                            <span
                              className=" mt-2"
                              style={{ color: "red", fontSize: "14px" }}
                            >
                              * File must be less then 2Mb
                            </span>
                            {multipleInvoiceData &&
                              multipleInvoiceData?.length >= 5 && (
                                <strong className="mx-4 mt-2">
                                  Maximum 5 allowed
                                </strong>
                              )}
                          </Box>
                          {multipleInvoiceData &&
                            multipleInvoiceData?.map((item, index) => {
                              return (
                                <InvoiceComponent
                                  key={`invoiceData-${index}`}
                                  getInvoice={(data) =>
                                    handleUpdateInvoiceData(data, index)
                                  }
                                  selectedFile={item}
                                  handleDelete={() => {
                                    handelDeleteInvoice(index);
                                  }}
                                  handleDeleteOnEdit={(key, spId) => {
                                    handleDeleteInvoiceOnEdit(key, spId);
                                  }}
                                  isEditing={isEdit}
                                  addNewInvoiceOnEdit={(file) => {
                                    addNewInvoiceOnEdit(file, index);
                                  }}
                                  submitInvRemark={(value) => {
                                    addRemarkForInvoice(value, index);
                                  }}
                                  handleAddInvoiceRemarks={(value) => {
                                    handleAddInvoiceRemarks(value, index);
                                  }}
                                  role={role}
                                />
                              );
                            })}
                        </div>
                      </div>
                      }
                    </Tab>
                    }
                    {hasAccess() && (
                      <Tab
                        eventKey="excel"
                        title={
                          <div className="d-flex">
                            Excel{" "}
                            <span className="mx-1 mt-1">
                              <RiFileDownloadLine />
                            </span>
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === 'excel' &&
                        <DownloadExcelFile
                          merchantValue={merchantValue}
                          prNo={generatedNum}
                          payAmount={totalPaymentAmount}
                          role={role}
                        />
                        }
                      </Tab>
                    )}
                    <Tab
                      eventKey="gst"
                      title={
                        <div className="d-flex ">
                          GST
                          {isGst && <FaCheck size={12} className="tab-icon" />}
                        </div>
                      }
                      className="add-form-tab"
                    >
                      {(activeTab === 'gst' || paymentStatus !== 1) &&
                      <div className="form-card">
                        <Box display="flex" alignItems="center">
                          <h5>GST Applicable</h5>
                          <Form.Check
                            className="mt-2 mx-1"
                            type="switch"
                            id="custom-switch"
                            onChange={() => handleToggleGstApplicable()}
                            checked={isGst}
                          />
                        </Box>

                        {isGst && (
                          <Box>
                            <div>
                              {multipleAddGstInfo &&
                                multipleAddGstInfo.map((item, index) => {
                                  return (
                                    <>
                                      <GstInfoComponent
                                        getData={(data) => {
                                          handleUpdateMultipleGstData(
                                            data,
                                            index
                                          );
                                        }}
                                        editData={editData}
                                        autoCount={index}
                                        gstData={item}
                                        refreshEditData={refreshEditData}
                                        gstAmountError={gstAmountError}
                                        isEdit={isEdit}
                                        taxableAmount={taxableAmount}
                                        merchantValue={merchantValue}
                                        expenseType={expenseType}
                                        role={role}
                                        deleteMultipleGstItem={() =>
                                          deleteMultipleGstItem(
                                            item?._id?._id,
                                            index
                                          )
                                        }
                                      />
                                    </>
                                  );
                                })}
                            </div>
                          </Box>
                        )}
                        {isGst && (
                          <Box
                            display="flex"
                            alignItems="center"
                            disabled={!isGst}
                          >
                            <h5>Add GST</h5>

                            <Button
                              className="add-project mt-2"
                              onClick={() => {
                                handleMultipleGstInfo(
                                  multipleAddGstInfo.length + 1
                                );
                              }}
                              disabled={isAddGstButtonVisible()}
                            >
                              <FaPlusCircle
                                className="add-project-icon"
                                size={15}
                              />
                            </Button>
                          </Box>
                        )}
                      </div>
                      }
                    </Tab>
                    <Tab
                      eventKey="tds"
                      title={
                        <div className="d-flex ">
                          TDS
                          {isTds && <FaCheck size={12} className="tab-icon" />}
                        </div>
                      }
                      className="add-form-tab"
                    >
                      {activeTab === 'tds' &&
                      <div className="form-card">
                        <Box display="flex" alignItems="center">
                          <h5>TDS Applicable</h5>
                          <Form.Check
                            className="mx-1 mt-2"
                            type="switch"
                            id="custom-switch"
                            onChange={() => handleToggleTDSApplicable()}
                            checked={isTds}
                            disabled={isTDSPoGenerated()}
                          />
                          {isTds && paymentStatus === 1 && (
                            <Box className="tds-po-gen" display="flex">
                              <Form.Label>
                                Do you want to generate TDS PO?
                              </Form.Label>
                              <Form.Check
                                type="switch"
                                id="custom-switch"
                                className="mx-1"
                                disabled={isTDSPoGenerated()}
                                onChange={handleToggleGenerateTDSPo}
                                checked={isGenerateTDSPo || isTDSPoGenerated()}
                                label={
                                  (isGenerateTDSPo || isTDSPoGenerated()) &&
                                  generatedTDSpoNum
                                }
                              />
                            </Box>
                          )}
                        </Box>
                        {isTds && (
                          <Box>
                            {multipleTdsInfo &&
                              multipleTdsInfo.map((item, index) => {
                                return (
                                  <>
                                    <TdsExpense
                                      getData={(data) => {
                                        handleUpdateMultipleTdsData(
                                          data,
                                          index
                                        );
                                      }}
                                      editData={editData}
                                      autoCount={index}
                                      tdsData={item}
                                      refreshEditData={refreshEditData}
                                      isEdit={isEdit}
                                      tdsAmountError={tdsAmountError}
                                      remainingTds={remainingTds}
                                      expenseType={expenseType}
                                      role={role}
                                      deleteMultipleTdsItem={() =>
                                        deleteMultipleTdsListItem(index)
                                      }
                                      isTDSPoGenerated={() =>
                                        isTDSPoGenerated()
                                      }
                                    />
                                  </>
                                );
                              })}
                          </Box>
                        )}
                        {isTds && (
                          <Box display="flex">
                            <Box display="flex">
                              <h5>Add TDS</h5>

                              <Button
                                className="add-project mt-2"
                                onClick={() => {
                                  handleMultipleTDSInfo(
                                    multipleTdsInfo.length + 1
                                  );
                                }}
                                disabled={isAddTdsButtonVisible()}
                              >
                                <FaPlusCircle
                                  className="add-project-icon mt-1"
                                  size={15}
                                />
                              </Button>
                            </Box>
                            <Box className="total-tds-amount">
                              <Text className="heading">Total Tds : </Text>
                              <Text className="value">
                                {formatAmountInINR(tdsAmount)}
                              </Text>
                            </Box>
                          </Box>
                        )}
                      </div>
                      }
                    </Tab>

                    {hasAccess() && (
                      <Tab
                        eventKey="freight_expense"
                        title={
                          <div className="d-flex ">
                            Freight Expense
                            {isFreight && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === 'freight_expense' &&
                        <div>
                          <Row className="mt-3 mb-0">
                            <Col>
                              <Box display="flex" className="mb-3">
                                <Form.Label>Is it Freight Expense?</Form.Label>
                                <Form.Check
                                  className="mx-3 mt-0"
                                  type="switch"
                                  id="custom-switch"
                                  onChange={() => setIsFreight(!isFreight)}
                                  checked={isFreight}
                                />
                              </Box>
                            </Col>
                          </Row>
                          {isFreight && (
                            <>
                              <Row className="mt-0 mb-3">
                                <Col>
                                  <Box display="flex" className="input-box">
                                    <Form.Label>Delivery Partner</Form.Label>
                                    <CustomSelect
                                      options={agencyOption}
                                      placeHolder={<div>Type or select...</div>}
                                      onChange={(newValue) =>
                                        setAgencyValue(newValue)
                                      }
                                      isSearchable
                                      onCreateOption={(e) => {
                                        createNewFormOption(
                                          createOption(e),
                                          "agency"
                                        );
                                      }}
                                      onDeleteOption={(option) => {
                                        deleteFromOption(option, "agency");
                                      }}
                                      onEditOption={(option, newValue) => {
                                        editFromOption(
                                          option,
                                          newValue,
                                          "agency"
                                        );
                                      }}
                                      defaultValue={agencyValue}
                                      role={role}
                                    />
                                  </Box>
                                </Col>
                                <Col>
                                  <Box display="flex" className="input-box">
                                    <Form.Label>Tracking Number</Form.Label>

                                    <Form.Control
                                      type="text"
                                      name="trackingNum"
                                      placeholder="Tracking Number"
                                      {...formik.getFieldProps("trackingNum")}
                                      defaultValue="XYZabc456qzvytr"
                                    />
                                  </Box>
                                </Col>
                              </Row>
                            </>
                          )}
                        </div>
                        }
                      </Tab>
                    )}
                    {hasAccess() && (
                      <Tab
                        eventKey="refund"
                        title={
                          <div className="d-flex ">
                            Refund
                            {isRefund && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        disabled={!multipleAddPaymentInfo?.length}
                        className="add-form-tab"
                      >
                        {activeTab === "refund" &&
                        <div className="form-card">
                          <Box display="flex" alignItems="center">
                            <h5>Refund Information</h5>
                            <Form.Check
                              className="mx-1 mt-2"
                              type="switch"
                              id="custom-switch"
                              checked={isRefund}
                              onChange={() => handleToggleRefundApplicable()}
                            />
                          </Box>

                          {isRefund && (
                            <Box>
                              {multipleAddRefundInfo &&
                                multipleAddRefundInfo?.map((item, index) => {
                                  return (
                                    <RefundInfoListComponent
                                      key={`refundInfo-${index}`}
                                      getData={(data) => {
                                        handleUpdateMultipleRefundData(
                                          data,
                                          index
                                        );
                                      }}
                                      autoCount={index}
                                      paymentData={item}
                                      editData={editData}
                                      refreshEditData={refreshEditData}
                                      deleteMultipleListItem={() =>
                                        deleteMultipleRefundListItem(index)
                                      }
                                      remainingAmount={remainingAmount}
                                      refundAmountError={refundAmountError}
                                      expenseType={expenseType}
                                      role={role}
                                    />
                                  );
                                })}
                            </Box>
                          )}
                          {isRefund && (
                            <Box display="flex" alignItems="center">
                              <h5>Add Refund</h5>

                              <Button
                                className="add-project mt-2"
                                onClick={() => {
                                  handleMultipleRefundInfo(
                                    multipleAddRefundInfo.length + 1
                                  );
                                }}
                                disabled={!isRefund}
                              >
                                <FaPlusCircle
                                  className="add-project-icon"
                                  size={15}
                                />
                              </Button>
                            </Box>
                          )}
                        </div>
                        }
                      </Tab>
                    )}
                    {hasAccess() && (
                      <Tab
                        eventKey="reimbursement"
                        title={
                          <div className="d-flex ">
                            Reimbursement
                            {formik.values.isReimburse && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === 'reimbursement' &&
                        <div className="form-card">
                          <Box
                            display="flex"
                            className="mb-3"
                            alignItems="center"
                          >
                            <h5>Reimbursement Information</h5>
                            <Form.Check
                              className="mx-1 mt-2"
                              type="switch"
                              id="custom-switch"
                              checked={formik.values.isReimburse}
                              {...formik.getFieldProps("isReimburse")}
                            />
                          </Box>

                          {formik.values.isReimburse && (
                            <Box>
                              <Row>
                                <Col>
                                  <Box display="flex" className="input-box">
                                    <Form.Label>Invoice Number</Form.Label>{" "}
                                    <Form.Control
                                      type="text"
                                      name="invoiceNum"
                                      placeholder="Invoice Number"
                                      defaultValue=""
                                      {...formik.getFieldProps("invoiceNum")}
                                    />
                                  </Box>
                                  <p className="form_error">
                                    {formik.errors.invoiceNum}
                                  </p>
                                </Col>
                                <Col>
                                  <Box display="flex" className="input-box">
                                    <Form.Label>Invoice Date</Form.Label>
                                    <Box>
                                      <DatePicker
                                        name="invoiceDate"
                                        className="monthDate"
                                        dateFormat="dd-MMM-yyyy"
                                        selected={invoiceDate}
                                        onChange={(date) =>
                                          setInvoiceDate(date)
                                        }
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                      />
                                    </Box>
                                  </Box>
                                </Col>
                              </Row>
                              <Row>
                                <Col className="switch-col mt-1">
                                  <Box display="flex" className="input-box">
                                    <Form.Label>Payment Date </Form.Label>

                                    <DatePicker
                                      name="reimbursePaymentDate"
                                      className="monthDate"
                                      dateFormat="dd-MMM-yyyy"
                                      selected={reimbursePaymentDate}
                                      onChange={(date) =>
                                        setReimbursePaymentDate(date)
                                      }
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                    />
                                  </Box>
                                </Col>
                                <Col>
                                  <Box display="flex" className="input-box">
                                    <Form.Label>Currency</Form.Label>
                                    <CustomSelect
                                      options={currencyOption}
                                      placeHolder={<div>Type or select...</div>}
                                      onChange={(newValue) =>
                                        setCurrencyValue(newValue)
                                      }
                                      isSearchable
                                      onCreateOption={(e) => {
                                        createNewFormOption(
                                          createOption(e),
                                          "currency"
                                        );
                                      }}
                                      onDeleteOption={(option) => {
                                        deleteFromOption(option, "currency");
                                      }}
                                      onEditOption={(option, newValue) => {
                                        editFromOption(
                                          option,
                                          newValue,
                                          "currency"
                                        );
                                      }}
                                      defaultValue={currencyValue}
                                      role={role}
                                    />
                                  </Box>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Box display="flex" className="input-box">
                                    <Form.Label>Amount</Form.Label>
                                    <CurrencyFormat
                                      customInput={Form.Control}
                                      type="text"
                                      onValueChange={(e) => {
                                        setTotalAmount(e.value);
                                      }}
                                      name="reimburseAmount"
                                      defaultValue={totalAmount}
                                      value={totalAmount || ""}
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                    />
                                  </Box>
                                </Col>
                                <Col>
                                  <Box display="flex" className="input-box">
                                    <Form.Label>Conversion Rate</Form.Label>

                                    <Form.Control
                                      type="number"
                                      name="conversionRate"
                                      placeholder="Coversion Rate"
                                      disabled={
                                        currencyValue &&
                                        currencyValue?.value === "INR"
                                      }
                                      onChange={(e) => {
                                        setINRVal(e.target.value);
                                      }}
                                      defaultValue={INRVal}
                                    />
                                  </Box>
                                </Col>
                              </Row>
                              {currencyValue?.label !== "INR" && (
                                <>
                                  <Row>
                                    <Col>
                                      <Box display="flex" className="input-box">
                                        <Form.Label>Amount in INR</Form.Label>
                                        <InputGroup>
                                          <InputGroup.Text>
                                            <span className="rupee-symbol">
                                              ₹
                                            </span>{" "}
                                          </InputGroup.Text>
                                          <CurrencyFormat
                                            customInput={Form.Control}
                                            type="text"
                                            onValueChange={formik.handleChange}
                                            name="amountInINR"
                                            disabled
                                            value={convertedVal || ""}
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                          />
                                        </InputGroup>
                                      </Box>
                                    </Col>
                                    <Col></Col>
                                  </Row>
                                </>
                              )}
                            </Box>
                          )}
                        </div>
                        }
                      </Tab>
                    )}

                    <Tab
                      eventKey="credit"
                      title={
                        <div className="d-flex ">
                          Credit
                          {isCredit && (
                            <FaCheck size={12} className="tab-icon" />
                          )}
                        </div>
                      }
                      className="add-form-tab"
                    >
                      {activeTab === "credit" &&
                      <div className="form-card">
                        <Box display="flex" alignItems="center">
                          <h5>Credit Utilized</h5>
                          <Form.Check
                            className="mx-1 mt-2"
                            type="switch"
                            id="custom-switch"
                            checked={isCredit}
                            onChange={() => handleToggleCreditApplicable()}
                          />
                          {paymentStatus === 1 && hasAccess() && (
                            <div
                              className="add-credit-btn"
                              onClick={() => setIsAddCredit(!isAddCredit)}
                            >
                              <FaPlus
                                size={12}
                                className="new-plus-icon mx-1"
                              />{" "}
                              New Credit
                            </div>
                          )}
                        </Box>
                        {isCredit && (
                          <Box>
                            {multipleCredit &&
                              multipleCredit?.map((item, index) => {
                                const isLastItem =
                                  index === multipleCredit.length - 1;

                                return (
                                  <CreditApplicable
                                    autoCount={index}
                                    isEdit={isEdit}
                                    getData={(data) =>
                                      handleUpdatedMultipleCredit(data)
                                    }
                                    creditItem={item}
                                    deleteCredit={(id, creditId) =>
                                      handleDeleteCredit(id, creditId)
                                    }
                                    creditError={creditError}
                                    editData={editData}
                                    maxAllowedCredit={
                                      remainingAmount + parseFloat(item?.usAmt || 0)
                                    }
                                    isCreditValid={setCreditValid}
                                    allCreditData={allCreditData}
                                    isDisabled={!isLastItem}
                                  />
                                );
                              })}
                          </Box>
                        )}

                        {isCredit && (
                          <Box display="flex" alignItems="center">
                            <h5>Add Credit</h5>

                            <Button
                              className="add-project mt-2"
                              onClick={() => setAddCredit(!addCredit)}
                              disabled={!validateCredits() || !isCredit}
                            >
                              <FaPlusCircle
                                className="add-project-icon"
                                size={15}
                              />
                            </Button>
                            <Box className="mt-2 mx-4">
                              {addCredit && (
                                <ClientProjectSelect
                                  options={allCreditOption}
                                  placeHolder={
                                    <div>Select Credit Number...</div>
                                  }
                                  onChange={(newValue) =>
                                    handleAddCredit(newValue)
                                  }
                                  isSearchable
                                  role={role}
                                />
                              )}
                            </Box>
                          </Box>
                        )}
                      </div>
                      }
                    </Tab>
                    {!hasAccess() &&
                    <Tab
                    eventKey="Invoices"
                    title={
                      <div className="d-flex ">
                        Invoices
                        {multipleInvoiceData && multipleInvoiceData?.length > 0 && <FaCheck size={12} className="tab-icon" />}
                      </div>
                    }
                    className="add-form-tab"
                  >
                    {activeTab === 'Invoices' &&
                    <div className="form-card">
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label className="bill-number">
                              Bill Number #
                            </Form.Label>

                            <Box>
                              <Form.Control
                                type="text"
                                name="billNumber"
                                placeholder="Bill Number"
                                onChange={(e) => {
                                  setBillNumber(e.target.value);
                                }}
                                value={billNumber}
                              />
                            </Box>
                          </Box>
                        </Col>
                        <Col></Col>
                      </Row>
                      <div
                        className="form-card"
                        style={{ marginBottom: "0px" }}
                      >
                        <Box display="flex" alignItems="center">
                          <h5>Invoice</h5>
                          <Button
                            className="add-project mt-1"
                            onClick={() => {
                              handleInvoiceChange();
                            }}
                          >
                            <FaPlusCircle
                              className="add-project-icon"
                              size={15}
                            />
                          </Button>
                        </Box>
                        <Box display="flex">
                          <span
                            className=" mt-2"
                            style={{ color: "red", fontSize: "14px" }}
                          >
                            * File must be less then 2Mb
                          </span>
                          {multipleInvoiceData &&
                            multipleInvoiceData?.length >= 5 && (
                              <strong className="mx-4 mt-2">
                                Maximum 5 allowed
                              </strong>
                            )}
                        </Box>
                        {multipleInvoiceData &&
                          multipleInvoiceData?.map((item, index) => {
                            return (
                              <InvoiceComponent
                                key={`invoiceData-${index}`}
                                getInvoice={(data) =>
                                  handleUpdateInvoiceData(data, index)
                                }
                                selectedFile={item}
                                handleDelete={() => {
                                  handelDeleteInvoice(index);
                                }}
                                handleDeleteOnEdit={(key, spId) => {
                                  handleDeleteInvoiceOnEdit(key, spId);
                                }}
                                isEditing={isEdit}
                                addNewInvoiceOnEdit={(file) => {
                                  addNewInvoiceOnEdit(file, index);
                                }}
                                handleAddInvoiceRemarks={(value) => {
                                  handleAddInvoiceRemarks(value, index);
                                }}
                                role={role}
                              />
                            );
                          })}
                      </div>
                    </div>
                    }
                  </Tab>
                    }
                  </Tabs>
                </div>

                {(role === "Manager" || role === "Admin") &&
                  activeList === "pending" &&
                  isEdit &&
                  paymentStatus === 0 && (
                    <>
                      <div className="form-card">
                        <h5>Approve OR Reject Remark</h5>

                        <Row>
                          <Col>
                            <Box display="flex" className="input-box">
                              <Form.Label>Remarks</Form.Label>
                              <TextAreaField
                                name="remarks"
                                value={approveOrRejectRemarks}
                                handleChange={(e) =>
                                  setApproveOrRejectRemarks(e.target.value)
                                }
                                isInvalid={
                                  !approveOrRejectRemarks &&
                                  errors?.approveOrRejectRemarks
                                }                             
                              />
                              
                            </Box>
                            {!approveOrRejectRemarks && (
                              <p className="form_error">
                                {errors?.approveOrRejectRemarks}
                              </p>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </>
                  )}
                <Row>
                  {(role === "Manager" || role === "Admin") &&
                  activeList === "pending" &&
                  isEdit &&
                  paymentStatus === 0 ? (
                    <ModalFooter
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      {paymentStatus !== 1 && (
                        <div className="d-flex">
                          <Button
                            variant="brand"
                            disabled={
                              totalPaymentAmount === null ? true : false
                            }
                            onClick={() => {
                              handleTotalPayAmountIsApproved(formik.values);
                            }}
                            className="submit-btn me-2"
                          >
                            Approve
                          </Button>

                          <Button
                            className="submit-btn"
                            variant="brand"
                            disabled={
                              totalPaymentAmount === null ? true : false
                            }
                            onClick={() => handleTotalPayAmountIsRejected()}
                            style={{ background: "#191063" }}
                          >
                            Reject
                          </Button>
                        </div>
                      )}
                    </ModalFooter>
                  ) : (
                    <ModalFooter>
                      {isSendRequest() ? (
                        <Button
                          variant="brand"
                          disabled={totalPaymentAmount === null ? true : false}
                          onClick={() => {
                            handleAmountApproveBtn(formik.values);
                          }}
                          className="submit-btn"
                        >
                          Send Request
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          variant="brand"
                          className="submit-btn"
                          onClick={() => setCompareDataModal(true)}
                          style={{ background: "#191063" }}
                        >
                          Submit
                        </Button>
                      )}
                    </ModalFooter>
                  )}
                </Row>
              </Form>
            </ModalBody>
          )}
        </ModalContent>
      </Modal>

      {compareDataModal && comparingData && (
        <ExpenseDataChangeModal
          openModal={compareDataModal}
          closeModal={closeComparedDataModal}
          editData={editData}
          currentData={comparingData}
          isConfirmed={() => {
            submitUpdateData(comparingData, editData);
          }}
          type={expenseType}
          role={role}
          moduleTyp={moduleInfo?.typ}
        />
      )}
      {openQuotation && (
        <QuotationForm
          isOpen={openQuotation}
          closeModal={() => {
            handleCloseQuotation();
          }}
          requestedAmount={approvalAmount}
          handleData={(data) => handleQuotationData(data)}
          uploadedData={quotationData}
          expenseId={editData?._id || ""}
          allQuotation={allQuotation}
        />
      )}
      {isAddCredit && (
        <CreditForm
          isOpen={isAddCredit}
          closeModal={() => {
            setIsAddCredit(false);
          }}
          remainingAmount={totalPaymentAmount}
          editData={editData}
          expenseType={expenseType}
          vendorId={merchantValue}
          role={role}
          moduleInfo={moduleInfo}
        />
      )}
    </>
  );
};

export default OrganizationExpenseForm;
